//cohort application form


import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
  // Select,
  MenuItem,
  ListItemText,
  InputBase,
  Grid,
  Box,
} from "@material-ui/core";
import api from "../common/dependencies/utils/Api";
import {
  GET_A_MENTOR_FORM,
  LOGIN_DATA,
  REGISTER_COHORT,
  SAVE_DRAFT_COHORT,
  GET_NAMES_DATA,
} from "../common/constants/ApplicationUrl";
import hashImage from "../../assets/images/hashImage.jpeg";
import { toast } from "react-toastify";
import { withRouter, useHistory } from "react-router-dom";
import GlobalDropDown from "../common/GlobalDropDown";

import { connect } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import FileUpload from "../common/FileUpload";
import InputField from "../common/InputField";
import FormValidator from "./FormValidator";
import SubmitForm from "./SubmitForm";
import swal from "sweetalert";
import * as moment from "moment";
import axios from "axios";

import MultiselectorComp from "../MultiselectorComp/MultiselectorComp.js";
// import { components } from "react-select";
import Select, { components, DropdownIndicatorProps } from "react-select";
import "./styles.scss";
import { registerCohort, savedraftCohort } from "./dependencies/action";
import { getPredefineOptionsList } from "../BecomeMentorForms/dependencies/action";
import { getNamesList } from "../AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/action";
// import makeAnimated from "react-select/animated";

// import { colourOptions } from "./data.js";
// const genders = [
//   {
//     value: "male",
//     label: "Male",
//   },
//   {
//     value: "female",
//     label: "Female",
//   },

//   {
//     value: "Other",
//     label: "Other",
//   },
//   {
//     value: "Prefer not to disclose",
//     label: "Prefer not to disclose",
//   },
// ];
const industryOptions = [
  { value: "Marketing", label: "Marketing" },
  {
    value: "Aeronautics Aerospace & Defense",
    label: "Aeronautics Aerospace & Defense",
  },
  { value: "AI", label: "AI" },
  { value: "Analytics", label: "Analytics" },
  { value: "Animation", label: "Animation" },
  { value: "AR VR", label: "AR VR" },
  {
    value: "Architecture Interior Design",
    label: "Architecture Interior Design",
  },
  { value: "Art & Photography", label: "Art & Photography" },
  { value: "Automotive", label: "Automotive" },
  { value: "Chemicals", label: "Chemicals" },
  {
    value: "Telecommunication & Networking",
    label: "Telecommunication & Networking",
  },
  { value: "Computer Vision", label: "Computer Vision" },
  { value: "Construction", label: "Construction" },
  { value: "Dating Matrimonial", label: "Dating Matrimonial" },
  { value: "Design", label: "Design" },
  { value: "Education", label: "Education" },
  { value: "Non-Renewable Energy", label: "Non-Renewable Energy" },
  { value: "Green Technology", label: "Green Technology" },
  { value: "Enterprise Software", label: "Enterprise Software" },
  { value: "Events", label: "Events" },
  { value: "Fashion", label: "Fashion" },
  { value: "Finance Technology", label: "Finance Technology" },
  { value: "Food & Beverage", label: "Food & Beverage" },
  { value: "Healthcare & Lifesciences", label: "Healthcare & Lifesciences" },
  { value: "Human Resources", label: "Human Resources" },
  { value: "Internet of Things", label: "Internet of Things" },
  { value: "IT Services", label: "IT Services" },
  { value: "Media & Entertainment", label: "Media & Entertainment" },
  { value: "Nanotechnology", label: "Nanotechnology" },
  { value: "Pets & Animals", label: "Pets & Animals" },
  {
    value: "Professional & Commercial Services",
    label: "Professional & Commercial Services",
  },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Retail", label: "Retail" },
  { value: "Robotics", label: "Robotics" },
  { value: "Safety", label: "Safety" },
  { value: "Security Solutions", label: "Security Solutions" },
  { value: "Household Services", label: "Household Services" },
  { value: "Social Impact", label: "Social Impact" },
  { value: "Social Network", label: "Social Network" },
  { value: "Sports", label: "Sports" },
  { value: "Textiles & Apparel", label: "Textiles & Apparel" },
  { value: "Transportation & Storage", label: "Transportation & Storage" },
  { value: "Travel & Tourism", label: "Travel & Tourism" },
  { value: "Advertising", label: "Advertising" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Others", label: "Others" },
  { value: "Logistics", label: "Logistics" },
  { value: "Airport Operations", label: "Airport Operations" },
  { value: "Waste Management", label: "Waste Management" },
  { value: "Passenger Experience", label: "Passenger Experience" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Indic Language Services", label: "Indic Language Services" },
];

const organizationtypeOptions = [
  {
    value: "Incubator",
    label: "Incubator",
  },
  { value: "Accelerator", label: "Accelerator" },
  { value: "Private Sector", label: "Private Sector" },
  { value: "Govt Sector", label: "Govt Sector" },
  {
    value: "Digital Ecosystem Connector",
    label: "Digital Ecosystem Connector",
  },
  { value: "Virtual Event Organizer", label: "Virtual Event Organizer" },
  { value: "Market Access Manager", label: "Market Access Manager" },
  { value: "Fund Manager", label: "Fund Manager" },
];

const specializationOptions = [
  {
    value: "Product Development and Technology",
    label: "Product Development and Technology",
  },
  { value: "Customer Acquisition", label: "Customer Acquisition" },
  { value: "Fundraising", label: "Fundraising" },
  { value: "Branding & Marketing", label: "Branding & Marketing" },
  { value: "Compliance & Legal", label: "Compliance & Legal" },
  { value: "Human Resource Management", label: "Human Resource Management" },
];

const preferredOptions = [
  { value: "Early Traction", label: "Early Traction" },
  { value: "Ideation", label: "Ideation" },
  { value: "Scaling", label: "Scaling" },
  { value: "Validation", label: "Validation" },
  // { value: "value F", label: "value F" },
  // { value: "value G", label: "value G" },
];

// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import { DropDownMenu, MenuItem } from "material-ui";

const useStyles = makeStyles((theme) => ({
  root:{
    "& .MuiFilledInput-root": {
      backgroundColor: "rgb(232, 241, 250) !important"
    },
    "& .MuiFilledInput-root:hover": {
      backgroundColor: "rgb(250, 232, 241) !important",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "rgb(232, 241, 250) !important"
      }
    },
    "& .MuiFilledInput-root.Mui-focused": {
      backgroundColor: "rgb(250, 241, 232) !important"
    }
    // "& .MuiInputBase-input .MuiOutlinedInput-input":{
    //   backgroundColor:"rbg(123,124,112)",
    // }
    // background:"red",
  },
  button: {
    leftbutton: {
      marginRight: theme.spacing(1),
      backgroundColor: "#3AC2D7",
      color: "#fff",
      width: "150px",
    },
    rightbutton: {
      marginRight: "8px",
      backgroundColor: "#f4f4f4",
      border: "1 solid #000",
      width: "150px",
    },
  },
 
}));

const customStyles = {
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
};
const customStylesCountry = {
  option: (provided, state) => ({
    ...provided,

    textAlign: "left",
  }),

  container: (provided, state) => ({
    ...provided,
    marginTop: 40,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    overflow: "visible",
  }),
  placeholder: (base, state) => ({
    ...base,
    position: "absolute",
    top:
      state.hasValue ||
      state.selectProps.inputValue ||
      state.selectProps.isFocused
        ? "-120%"
        : "0%",
    transition: "top 0.2s, font-size 0.2s",
    fontSize:
      (state.hasValue ||
        state.selectProps.inputValue ||
        state.selectProps.isFocused) &&
      14,
    marginLeft:
      (state.hasValue ||
        state.selectProps.inputValue ||
        state.selectProps.isFocused) &&
      -10,
  }),
};

function getSteps() {
  return [
    "APPLICANT DETAILS",
    "PROGRAM DETAILS",
    // "PROGRAM CONSTRUCT",
    "COHORT PREFERENCES",
    // "DOCUMENT UPLOAD",
    // "DISCLAIMER",
  ];
}

const names = [
  { id: "1", value: "Oliver Hansen" },
  { id: "2", value: "Van Henry" },
  { id: "3", value: "Van Henry" },
];

const LinearStepperCohort = (props) => {
  const {
    registerCohort,
    getPredefineOptionsList,
    savedraftCohort,

    getPredefineOptions,
    getNamesList,
    getNamesListData,
  } = props;
  const imgRef = useRef();
  const history = useHistory();
  const [enrolementDefault, setenrolementDefault] = useState([]);

  const newEnarray = [];
  const newFuncarray = [];
  const newIndarray = [];
  const newStagearray = [];
  // useEffect(() => {

  //   if (history?.location?.state?.data?.mentorenrolmentid?.length > 0) {
  //     history?.location?.state?.data?.mentorenrolmentid?.length > 0 &&
  //       history?.location?.state?.data?.mentorenrolmentid.forEach((element) => {
  //         // const updatedList = [...enrolementDefault, element];
  //         // setIndustryDefault(updatedList)
  //         let params = {
  //           // label: `M${element.slice(-6)}` + " (" + element.name + ")",
  //           label: `M${element.slice(-6)}`,

  //           value: element,
  //         };
  //         // setFormData((user) => {
  //         newEnarray.push(params);
  //       });

  //     history?.location?.state?.data?.specialization?.length > 0 &&
  //       history?.location?.state?.data?.specialization.forEach((element) => {
  //         // const updatedList = [...enrolementDefault, element];
  //         // setIndustryDefault(updatedList)
  //         let params = {
  //           label: element,
  //           value: element,
  //         };
  //         // setFormData((user) => {
  //         newFuncarray.push(params);
  //       });
  //     history?.location?.state?.data?.industry &&
  //       history?.location?.state?.data?.industry?.length > 0 &&
  //       history?.location?.state?.data?.industry?.forEach((element) => {
  //         // const updatedList = [...enrolementDefault, element];
  //         // setIndustryDefault(updatedList)
  //         let params = {
  //           label: element,
  //           value: element,
  //         };
  //         // setFormData((user) => {
  //         newIndarray.push(params);
  //       });

  //     history?.location?.state?.data?.preferred_stage?.length > 0 &&
  //       history?.location?.state?.data?.preferred_stage.forEach((element) => {
  //         // const updatedList = [...enrolementDefault, element];
  //         // setIndustryDefault(updatedList)
  //         let params = {
  //           label: element,
  //           value: element,
  //         };
  //         // setFormData((user) => {
  //         newStagearray.push(params);
  //       });
  //     // setenrolementDefault(newEnarray);
  //   }
  // }, []);

  // const arrfiltered2 = arr2.filter(function (elem) {
  //   return elem.value != arr.indexOf(elem).value;
  // });
  const defaultFormData = {
    cohortId: "",
    mentor_name:
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData")).name,
    // gender: "",
    industry: newIndarray,
    enrolementIds2: newEnarray,
    // enrolementIds2: newonearray,
    // enrolementIds2:
    //   localStorage.getItem("newEnarray") &&
    //   JSON.parse(localStorage.getItem("newEnarray")),
    subindustry: [],
    specialization: newFuncarray,
    subspecialization: [],
    preferredStage: newStagearray,
    uploadAttach:
      history?.location?.state && history?.location?.state.data?.uploadAttach,
    disclaimer: false,
    uploadLogo: null,
    uploadBanner: null,
    uploadBanner: null,
    enrolementIds: [],

    // full_name: autoFetchedData.name ? autoFetchedData.name : "",
    // full_name: "",
    // dpiit_no: "",
    // sector: autoFetchedData.sectors ? autoFetchedData.sectors[0] : "",
    // industry: autoFetchedData.industry ? autoFetchedData.industry : "",
    // stage: autoFetchedData.stage ? autoFetchedData.stage : "",
    // applicant_name: autoFetchedData.applicant_name
    //   ? autoFetchedData.applicant_name
    //   : "",
    // designation: "",
    country: "",
    // email_id: autoFetchedData.email ? autoFetchedData.email : "",
    program_name: "",
    program_desc: "",
    program_duration: "",
    cohort_date: "",
    startup_start_date: "",
    startup_end_date: "",
    program_duration_text: "",
    // contact_no: autoFetchedData.phone ? autoFetchedData.phone : "",
    phone_number: "",
    state: "",
    city: "",
    organization_name:
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData")).organization_name,
    organization_type: "",
    current_designation: "",
    // numberofmentors: "2",
    // hoursperweek: "",
    // mentorenrolmentid: "",
    // numberofstartups: "",
    linkedinurl: "",
    personalblogurl: "",
    infiniteDuration:"",
    cohortVisibility:"",
    // AppLindin_url: "",
    // startupwebsite: "",
    // curret_revenue: "",
    // offered_startup: "",
    // problem_solved: "",
    // whyneedMentorship: "",
    // expected_outcome: "",
    // preffered_sector: "",
    // preffered_function: "",
    // current_stage: "",
    // startup_video_url: "",
  };
  const presentDate01 = new Date().toISOString().split('T')[0];
  const classes = useStyles();
  const [cohortPrivate,setCohortPrivate] = useState(false);
  const [cohortPublic,setCohortPublic] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skippedSteps, setSkippedSteps] = useState([]);
  const [genderfocused, setGenderFocused] = useState(false);
  // const steps = getSteps();
  const [industry, setIndustry] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [preferredStage, setPreferredStage] = useState([]);
  const [optionSelected, setOptionSelected] = useState(null);
  const [organizationType, setOrganizationType] = useState("");
  const [showSubmitCohort, setShowSubmitCohort] = useState(false);
  const [submitFormData, setSubmitFormData] = useState({});
  const [loginDatajsonNew, setLoginDatajson] = useState({});
  const [profileExistingImg, setProfileExistingImg] = useState();
  const [bannerExistingImg, setBannerExistingImg] = useState();
  const [error, setError] = useState({});
  const [mentorEnrolmentIdList, setMentorEnrolmentIdList] = useState([
    { mentorenrolmentid: "" },
  ]);
  const [mentorEnrolmentIdList2, setMentorEnrolmentIdList2] = useState([]);
  const [formPercentageValue, setFormPercentageValue] = useState(0);
  const [formData, setFormData] = useState(defaultFormData);
  const [cohortDate, setCohortDate] = useState("");
  const [date, setDate] = useState("");
  const [date2, setDate2] = useState("");
  const [time, setTime] = useState("");
  const [wordLimit, setWordlimit] = useState();
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the Description of program"
  );
  const [cohortApplicationId, setCohortApplicationId] = useState();
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [wordCounter, setWordCounter] = useState(0);
  const [industryDefault, setIndustryDefault] = useState([]);
  const [specializationDefault, setSpecializationDefault] = useState([]);
  const [typeDefault, setTypeDefault] = useState([]);
  const [stageDefault, setStageDefault] = useState([]);
  const [defaultMentorID, setDefaultMentorID] = useState([]);
  const [nameListValue, setNameListValue] = useState([]);
  const [nameListData, setNamesListData] = useState([]);
  const [nameListDatafirst, setNamesListDatafirst] = useState([]);
  const [modifiedEndDate, setModifiedEndDate] = useState();
  const [isNext, setIsNext] = useState(true);
  const [isPrevious, setIsPrevious] = useState(true);
  const [cohortStartDateParsed, setCohortStartDateParsed] = useState(
    formData.cohort_date
  );
  const [cohortEndDateParsed, setCohortEndDateParsed] = useState();
  const [cohortstartupstartdate, setCohortstartupstartdate] = useState();
  const [filterOutData, setFilterOutData] = useState();
  const [newenarraynew, setNewenarraynew] = useState();
  const [progdurnumber, setNewprogdurnumber] = useState(
    history?.location?.state?.data?.program_duration
  );
  const [infiniteDuration,setInfiniteDuration] = useState(false);
  const [cohortVisibility,setCohortVisibility] = useState(false);

  // const progdurationumber = history?.location?.state?.data?.program_duration;
  const progdurationumber =
    progdurnumber > 12 ? 12 : progdurnumber < 3 ? 3 : progdurnumber;
  // const progdurationumber = 11;

  useEffect(() => {
    var d = new Date();
    const newone = new Date(d.setMonth(d.getMonth() + 3));

    const cohrotnewdate2 = new Date(
      history?.location?.state?.data?.date_updated
    );
    const cohrotdatestrtupenddate = new Date(
      history?.location?.state?.data?.startup_end_date
    );

    const cohrotdatestrtupstartdate = new Date(
      history?.location?.state?.data?.startup_start_date
    );

    const latercohortstartstrtupDate = cohrotdatestrtupstartdate.setDate(
      cohrotdatestrtupstartdate.getDate() + 15
    );

    const newdatelatercohortstrtupstrtDate = new Date(
      latercohortstartstrtupDate
    );

    // const cohortendnewdatestrtupstartdateparsed =

    //   newdatelatercohortstrtupstrtDate.toISOString().slice(0, 10);
    setCohortstartupstartdate(newdatelatercohortstrtupstrtDate);

    // const cohrotdatestrtupenddateparsed = cohrotdatestrtupenddate?.toISOString().slice(0, 10)
    const cohrotnewdate2threemonths = new Date(
      cohrotnewdate2.setMonth(
        // cohrotnewdate2.getMonth() + parseInt(progdurationumber)
        cohrotnewdate2.getMonth() + parseInt(progdurationumber)
      )
    );
    var maxDate = new Date(cohrotnewdate2threemonths);
    maxDate.setDate(maxDate.getDate() - 1);
    const latercohortDate2 = cohrotnewdate2.setDate(
      cohrotnewdate2.getDate() + 15
    );

    const newdatelatercohortDate2 = new Date(latercohortDate2);

    const cohortendnewdateparsed2 =
      history?.location?.state?.mode === "edit" &&
      history?.location?.state?.data?.applicationStatus === "VERIFIED" &&
      newdatelatercohortDate2?.toISOString().slice(0, 10);
    // setCohortEndDateParsed(cohortendnewdateparsed2);
    setCohortEndDateParsed(
      history?.location?.state?.mode === "edit" &&
        history?.location?.state?.data?.applicationStatus === "VERIFIED"
        ? maxDate?.toISOString().slice(0, 10)
        : // cohrotdatestrtupenddate?.toISOString().slice(0, 10)
          cohortendnewdateparsed2
    );
  }, [progdurnumber]);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }
  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    // let params = {
    //   listKey: "Mentor",
    // };
    // getNamesList(params);

    // axios({
    //   url: GET_NAMES_DATA,
    //   method: "post",
    //   data: {
    //     // mentorId:
    //     //   localStorage.getItem("SavedLoggedInData") &&
    //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Mentor",
    //   },
    // })
    api
      .POST(GET_NAMES_DATA, {
        // mentorId:
        //   localStorage.getItem("SavedLoggedInData") &&
        //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Mentor",
      })
      .then((res) => {
        setNamesListData(res.data.data);
        setNamesListDatafirst(res.data.data);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    let params = {
      listKey: "Mentor",
    };
    getNamesList(params);
  }, []);

  let mentroenroltagArray = [];
  useEffect(() => {
    setIsNext(true);

    if (history?.location?.state?.data?.mentorenrolmentid?.length > 0) {
      history?.location?.state?.data?.mentorenrolmentid?.length > 0 &&
        history?.location?.state?.data?.mentorenrolmentid.forEach((element) => {
          // const updatedList = [...enrolementDefault, element];
          // setIndustryDefault(updatedList)
          const filterout = nameListData.filter(function (elem) {
            return element === elem.id;
          });
          // setFilterOutData(filterout);
          // localStorage.setItem("filteroutName", filterout[0]?.name);
          let newObject = {
            label: `M${element.slice(-6)}` + " (" + filterout[0]?.name + ")",
            value: element,
          };

          let params = {
            label: `M${element.slice(-6)}`,
            // label: `M${element.slice(-6)}`,

            value: element,
          };

          // setFormData((user) => {
          // newEnarray.push(params);
          setFormData((user) => {
            return { ...user, enrolementIds2: newEnarray };
          });
          newEnarray.push(newObject);
          setNewenarraynew(newEnarray);
          mentroenroltagArray.push(newObject);
          // localStorage.setItem("newEnarray", JSON.stringify(newEnarray));
          // setenrolementDefault(newEnarray);
        });

      history?.location?.state?.data?.specialization?.length > 0 &&
        history?.location?.state?.data?.specialization.forEach((element) => {
          // const updatedList = [...enrolementDefault, element];
          // setIndustryDefault(updatedList)
          let params = {
            label: element,
            value: element,
          };
          // setFormData((user) => {
          newFuncarray.push(params);
        });
      history?.location?.state?.data?.industry &&
        history?.location?.state?.data?.industry?.length > 0 &&
        history?.location?.state?.data?.industry?.forEach((element) => {
          // const updatedList = [...enrolementDefault, element];
          // setIndustryDefault(updatedList)
          let params = {
            label: element,
            value: element,
          };
          // setFormData((user) => {
          newIndarray.push(params);
        });

      history?.location?.state?.data?.preferred_stage?.length > 0 &&
        history?.location?.state?.data?.preferred_stage.forEach((element) => {
          // const updatedList = [...enrolementDefault, element];
          // setIndustryDefault(updatedList)
          let params = {
            label: element,
            value: element,
          };
          // setFormData((user) => {
          newStagearray.push(params);
        });
      // setenrolementDefault(newEnarray);
    }
  }, [nameListData]);

  useEffect(() => {
    nameListData?.forEach((element, index) => {
      const testDuplicate = nameListValue.filter(function (element) {
        return element.value == "Select";
      });
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Mentor",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      if(element?.id !== loginDataJson?.id)
      {
        let arr = {
          value: element.id,
          label: `M${element.id.slice(-6)}` + " (" + element.name + ")",
        };
        if (nameListData?.length >= nameListValue?.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
      }
  
     
    });
  }, [nameListData]);
  useEffect(() => {
    if (history?.location?.state && history?.location?.state?.data?.id) {
      setCohortApplicationId(
        history?.location?.state && history?.location?.state?.data?.id
      );
    }
    setBannerExistingImg(history?.location?.state?.data?.uploadBanner);
    setProfileExistingImg(history?.location?.state?.data?.uploadLogo);
    let arr1=[];
    let arr2=[];
    let arr3=[];
    if (
      (history?.location?.state &&
        history?.location?.state?.data?.uploadBanner != "") ||
      history?.location?.state?.data?.uploadBanner != null ||
      history?.location?.state?.data?.uploadBanner != undefined
    ) {
      localStorage.setItem(
        "uploadBanner",
        history?.location?.state?.data?.uploadBanner
      );
    } else {
      localStorage.removeItem("uploadBanner");
    }

    if (
      history?.location?.state !== undefined &&
      history?.location?.state !== null &&
      history?.location?.state !== ""
    ) {
      let data;
      if (
        history?.location?.state?.mode !== undefined &&
        history?.location?.state?.mode !== null &&
        history?.location?.state?.mode !== "" &&
        (history?.location?.state?.mode === "edit" ||
          history?.location?.state?.mode === "create")
      ) {
        data = history?.location?.state?.data;
      } else {
        data = history?.location?.state;
      }
      if (
        history?.location?.state?.data?.industry &&
        history?.location?.state?.data?.industry?.length > 0 &&
        Array.isArray(history?.location?.state?.data?.industry)
      ) {
        history?.location?.state?.data?.industry.forEach((element) => {
          const updatedList = [...industryDefault, element];
          // setIndustryDefault(updatedList)
          let params = {
            label: element,
            value: element,
          };
          arr1.push(params)
          setIndustryDefault((current) => [...current, params]);
        });
      }
      if (history?.location?.state?.data?.specialization?.length > 0) {
        history?.location?.state?.data?.specialization.forEach((element) => {
          const updatedList = [...specializationDefault, element];
          // setIndustryDefault(updatedList)
          let params = {
            label: element,
            value: element,
          };
          setSpecializationDefault((current) => [...current, params]);
          arr2.push(params)
        });
      }
      // if (history?.location?.state?.mentorenrolmentid?.length > 0) {
      //   history?.location?.state?.mentorenrolmentid.forEach((element) => {
      //     const updatedList = [...enrolementDefault, element];
      //     // setIndustryDefault(updatedList)
      //     let params = {
      //       label: `M${element.slice(-6)}`,
      //       value: element,
      //     };
      //     // setFormData((user) => {

      //     setenrolementDefault((current) => [...current, params]);
      //   });
      // }
      // if (history?.location?.state?.mentorenrolmentid?.length > 0) {
      //   history?.location?.state?.mentorenrolmentid.forEach((element) => {
      //     const updatedList = [...defaultMentorID, element];
      //     // setIndustryDefault(updatedList)
      //     setDefaultMentorID((current) => [...current, updatedList]);
      //   });
      // }
      if (history?.location?.state?.data?.organization_type !== "") {
        let params = {
          label: history?.location?.state?.data?.organization_type,
          value: history?.location?.state?.data?.organization_type,
        };
        setTypeDefault((current) => [...current, params]);
      }

      if (history?.location?.state?.data?.preferred_stage?.length > 0) {
        history?.location?.state?.data?.preferred_stage.forEach((element) => {
          // const updatedList = [...stageDefault, element];
          // setIndustryDefault(updatedList)
          let params = {
            label: element,
            value: element,
          };
          setStageDefault((current) => [...current, params]);
          arr3.push(params)
        });
        // let params = {
        //   label: history?.location?.state?.preferred_stage[0],
        //   value: history?.location?.state?.program_name[0]
        // }
        // setStageDefault((current) => [...current, params]);
      }
      if(data?.infiniteDuration !== undefined && data?.infiniteDuration !== "" && data?.infiniteDuration !== null &&  data?.infiniteDuration)
      {
        setInfiniteDuration(true)
      }
      if(data?.cohortVisibility !== undefined && data?.cohortVisibility !== "" && data?.cohortVisibility !== null)
      {
        if(data?.cohortVisibility)
        {
          setCohortPrivate(false);
          setCohortPublic(true);
        }
        else{
          setCohortPrivate(true);
          setCohortPublic(false);
        }
      }
      setFormData((user) => {
        return {
          ...user,
          mentor_name:
            data?.mentor_name === undefined
              ? // data?.name
                localStorage.getItem("SavedLoggedInData") &&
                JSON.parse(localStorage.getItem("SavedLoggedInData")).name
              : data?.mentor_name,
          organization_name:
            data?.organization_name === undefined
              ? localStorage.getItem("SavedLoggedInData") &&
                JSON.parse(localStorage.getItem("SavedLoggedInData"))
                  .organization_name
              : data?.organization_name,
          organization_type: data?.organization_type,
          program_name: data?.program_name,
          program_desc: data?.program_desc,
          program_duration: data?.program_duration,
          cohort_date: data?.cohort_date
            ? moment(data?.cohort_date).format("YYYY-MM-DD")
            : "",
          startup_start_date: data?.startup_start_date
            ? moment(data?.startup_start_date).format("YYYY-MM-DD")
            : "",
          // startup_end_date: data?.date_updated
          //   ? moment(
          //       moment(data?.date_updated).add(15, "d").format("YYYY-MM-DD")
          //     )._i
          //   : "",
          startup_end_date: data?.startup_end_date
            ? moment(data?.startup_end_date).format("YYYY-MM-DD")
            : "",
          // hoursperweek: data?.hoursperweek,
          // numberofmentors: data?.numberofmentors,
          // mentorenrolmentid: data?.mentorenrolmentid,
          // numberofstartups: data?.numberofstartups,
          uploadLogo:
            data?.uploadLogo === undefined ? hashImage : data?.uploadLogo,
          uploadBanner: data?.uploadBanner,
          infiniteDuration:data?.infiniteDuration,
          cohortVisibility:data?.cohortVisibility,
          industry: arr1,
          // enrolementIds2: data.enrolementIds2,
          specialization: arr2,
          preferredStage: arr3,
        };
      });
      // setFormData((user) => {
      //   return { ...user, program_name: data.program_name };
      // });
    }
    // if(history.)
  }, []);
  const [formPercentage, setFormPercentage] = useState({
    fullName: {
      value: true,
      weightage: 11,
    },
    currentOrganization: {
      value: false,
      weightage: 11,
    },
    typeOrganization: {
      value: false,
      weightage: 11,
    },
    programName: {
      value: false,
      weightage: 8.25,
    },
    programDescription: {
      value: false,
      weightage: 8.25,
    },
    imageBanner: {
      value: false,
      weightage: 8.25,
    },
    program_duration: {
      value: false,
      weightage: 8.25,
    },
    cohortStartDate: {
      value: false,
      weightage: 3.5,
    },
    startUpStartDate: {
      value: false,
      weightage: 3.5,
    },
    startUpEndDate: {
      value: false,
      weightage: 3.5,
    },
    // hoursDedicated: {
    //   value: false,
    //   weightage: 8,
    // },
    // mentorsCount: {
    //   value: false,
    //   weightage: 8,
    // },
    // enrollmentId: {
    //   value: false,
    //   weightage:9,
    // },
    // mentorDocs: {
    //   value: false,
    //   weightage: 0,
    // },
    // startUpCount: {
    //   value: false,
    //   weightage: 0,
    // },
    // function: {
    //   value: false,
    //   weightage: 12,
    // },
    cohortType:{
      value: false,
      weightage: 12,
    },
    termsConfirmation: {
      value: false,
      weightage: 22,
    },
  });
  const generatePercentageData = (params) => {
    let step0output =
      (formData?.mentor_name !== "" ? formPercentage.fullName.weightage : 0) +
      (formData?.organization_name !== "" &&
      formData?.organization_name !== null
        ? formPercentage.currentOrganization.weightage
        : 0) +
      (formData?.organization_type &&
      formData?.organization_type !== "" &&
      formPercentage?.organization_type !== null
        ? formPercentage.typeOrganization.weightage
        : 0);
    let step1output =
      (formData?.program_name &&
      formData?.program_name !== "" &&
      formData?.program_name !== null
        ? formPercentage.programName.weightage
        : 0) +
      (formData?.program_desc &&
      formData?.program_desc !== "" &&
      formData?.program_desc !== null
        ? formPercentage.programDescription.weightage
        : 0) +
      ((formData?.uploadBanner !== "" && formData?.uploadBanner !== null && formData?.uploadBanner !== undefined ) ||
     ( bannerExistingImg !== "" && bannerExistingImg !== null && bannerExistingImg !== undefined)
        ? formPercentage.imageBanner.weightage
        : 0) +
      ((formData?.program_duration &&
      formData?.program_duration !== "" &&
      formData?.program_duration !== null &&
      formData?.program_duration >= 3) || infiniteDuration
        ? formPercentage.program_duration.weightage
        : 0);
    //   +
    // (formData?.cohort_date !== "" && formData?.cohort_date !== null
    //   ? formPercentage.cohortStartDate.weightage
    //   : 0) +
    // (formData?.startup_start_date !== "" &&
    // formData?.startup_start_date !== null
    //   ? formPercentage.startUpStartDate.weightage
    //   : 0) +
    // (formData?.startup_end_date !== "" && formData?.startup_end_date !== null
    //   ? formPercentage.startUpEndDate.weightage
    //   : 0);
    // let step2output =
    //   (formData?.hoursperweek !== "" && formData?.hoursperweek !== null
    //     ? formPercentage.hoursDedicated.weightage
    //     : 0) +
    //   (formData?.numberofmentors !== "" && formData?.numberofmentors !== null
    //     ? formPercentage.mentorsCount.weightage
    //     : 0) +
    //   (formData?.enrolementIds !== "" &&
    //   formData?.enrolementIds2 !== null &&
    //   formData?.enrolementIds2.length > 0
    //     ? formPercentage.enrollmentId.weightage
    //     : 0) ;

      // +(formData?.uploadAttach !== "" && formData?.uploadAttach !== null
      //   ? formPercentage.mentorDocs.weightage
      //   : 0)

    let step3output =
      // (formData?.numberofstartups !== "" && formData?.numberofstartups !== null
      //   ? formPercentage.startUpCount.weightage
      //   : 0) +
      // (formData?.specialization?.length > 0
      //   ? formPercentage.function.weightage
      //   : 0) +
      (formData?.disclaimer !== false
        ? formPercentage.termsConfirmation.weightage
        : 0)+
        ((formData?.cohortVisibility !== "" && formData?.cohortVisibility !== undefined && formData?.cohortVisibility !== null)
          ? formPercentage.cohortType.weightage
          : 0)
        // ((cohortPrivate || cohortPublic)
        // ? formPercentage.cohortType.weightage
        // : 0);
     

    if (activeStep == 0) {
      setFormPercentageValue(step0output);
    }

    if (activeStep == 1) {
      setFormPercentageValue(step0output + step1output);
    } else if (activeStep == 2) {
      setFormPercentageValue(
        step0output + step1output  + step3output
      );
      // setFormPercentageValue(step0output + step1output + step2output);
    } 
    // else if (activeStep == 3) {
    //   // setFormPercentageValue(
    //   //   step0output + step1output + step2output + step3output
    //   // );
    // }
  };

  const tomorrowDate = new Date().setDate(new Date().getDate() + 1);
  const tomorrowDateFinal = new Date(tomorrowDate);
  // const startupstartDate = new Date().setDate(new Date().getDate() + 2);

  useEffect(() => {
    const todayDate = new Date().toISOString().slice(0, 10);
    // const tomorrowDate = new Date().setDate(new Date().getDate() + 1);
    // const tomorrowDateFinal = new Date(tomorrowDate);
    generatePercentageData();
  }, [activeStep]);
  useEffect(() => {
    generatePercentageData();
 
  }, [formData]);
useEffect(()=>{
  if(cohortPrivate){
    setFormData((user) => {
      return { ...user, cohortVisibility: false };
    });
  }
  else if(cohortPublic){
    setFormData((user) => {
      return { ...user, cohortVisibility: true };
    });
  }
},[cohortPrivate,cohortPublic])
useEffect(()=>{
  if(infiniteDuration){
    setFormData((user) => {
      return { ...user, infiniteDuration: true,program_duration:"" };
    });
  }
  else if(!infiniteDuration){
    setFormData((user) => {
      return { ...user, infiniteDuration: false };
    });
  }
},[infiniteDuration])
// useEffect(()=>{
//   if(infiniteDuration){
//     setFormData((user) => {
//       return { ...user, infiniteDuration: true };
//     });
//   }
//   else if(infiniteDuration){
//     setFormData((user) => {
//       return { ...user, infiniteDuration: false };
//     });
//   }
// },[infiniteDuration])
  // useEffect(() => {
  //   if (formData.numberofmentors === "2") {
  //     setMentorEnrolmentIdList([
  //       ...mentorEnrolmentIdList,
  //       { mentorenrolmentid: "" },
  //     ]);
  //   }
  // }, []);

  // const {
  //   registerCohort,
  //   getPredefineOptionsList,
  //   savedraftCohort,

  //   getPredefineOptions,
  //   getNamesList,
  //   getNamesListData
  // } = props;
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
    useState(false);
  const [userId, setUserId] = useState("");
  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 250) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 250 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter Description of program");
    } else if (value == 0) {
      SetErrorVisible7(true);
      // document.getElementById("mentoratstartup").value = "";
    } else if (value == 251) {
      setWordCounter(100);
      return value;
    }
    setWordCounter(value);
    return value;
  };
  const loginDataJson = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  useEffect(() => {
    const newId = loginDataJson?.id;

    // alert(newId)
    setUserId(newId);
    setLoginDatajson(loginDataJson);
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      let data = JSON.parse(localStorage.getItem("SavedLoggedInData"));

      // setData(JSON.parse(value))
    } catch (error) {}
  }, []);
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    if(history?.location?.state?.mode === "edit" && infiniteDuration)
    {
      setFormData((user) => {
        return { ...user, startup_end_date: "" };
      });
    }
   }, [])
  const removeFile = (fileType) => {
    if (fileType === "uploadAttach") {
      setFormData((user) => {
        return { ...user, ["uploadAttach"]: null };
      });
    }
  };
  const previewProfilePic = (file) => {
    if (FileReader) {
      var reader = new FileReader();
      // if(file?.target?.files[0]){
      reader.readAsDataURL(file);
      // }
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          document.getElementById("fileUpload-profile-pic").src = image.src;
        };
      };
    }
  };
  const previewProfilePic2 = (file) => {
    if (FileReader) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          document.getElementById("fileUpload-profile-pic2").src = image.src;
        };
      };
    }
  };
  const validateStep1Input = () => {
    const { mentor_name, organization_name, organization_type } = formData;
    const formStatus = FormValidator.validateStep1({
      mentor_name,
      organization_name,
      organization_type,
    });

    const errors = {
      mentorname: formStatus.mentorname,
      // gender: formStatus.gender,
      organizationname: formStatus.organizationname,
      organization_type: formStatus.organization_type,
      // orgName: formStatus.orgName,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };

  const onclickShowSubmitCohort = (Id) => {
    // setActivityFellowId(Id);
    setShowSubmitCohort(true);
  };

  const clickOnClose = () => {
    setShowSubmitCohort((x) => !x);
    // getActivityFellow()
  };
  const validateStep2Input = () => {
    const {
      program_name,
      program_desc,
      uploadBanner,
      program_duration,
      cohort_date,
      startup_start_date,
      startup_end_date,
      program_duration_text,
      infiniteDuration,
    } = formData;

    if (
      history?.location?.state?.mode === "edit" &&
      history?.location?.state?.data?.applicationStatus === "VERIFIED"
    ) {
      const formStatus = FormValidator.validateStep2({
        program_name,
        program_desc,
        uploadBanner,
        program_duration,
        cohort_date,
        startup_start_date,
        startup_end_date,
        program_duration_text,
        infiniteDuration,
      });

      const errors = {
        programname: formStatus.programname,
        programdesc: formStatus.programdesc,
        uploadBanner: formStatus.uploadBanner,
        program_duration: formStatus.program_duration,
        cohort_date: formStatus.cohort_date,
        startup_start_date: formStatus.startup_start_date,
        startup_end_date: formStatus.startup_end_date,
        program_duration_text: formStatus.program_duration_text,
      };
      setError(errors);
      return !formStatus.hasErrors;
    } else {
      const formStatus = FormValidator.validateStep2newcohort({
        program_name,
        program_desc,
        uploadBanner,
        program_duration,
        infiniteDuration,
        program_duration_text,
      });

      const errors = {
        programname: formStatus.programname,
        programdesc: formStatus.programdesc,
        uploadBanner: formStatus.uploadBanner,
        program_duration: formStatus.program_duration,

        program_duration_text: formStatus.program_duration_text,
      };
      setError(errors);
      return !formStatus.hasErrors;
    }
  };

  const validateStep3Input = (defaultMentorID) => {
    const {
      hoursperweek,
      numberofmentors,
      enrolementIds2,
      // uploadAttach,
      // mentorenrolmentid,
    } = formData;
    const formStatus = FormValidator.validateStep3({
      hoursperweek,
      numberofmentors,
      enrolementIds2,
      // uploadAttach,
      // mentorenrolmentid,
      // mentorEnrolmentIdList,
      // defaultMentorID,
    });

    const errors = {
      hoursperweek: formStatus.hoursperweek,
      numberofmentors: formStatus.numberofmentors,
      enrolementIds2: formStatus.enrolementIds2,
      // uploadAttach: formStatus.uploadAttach,
      // mentorenrolmentid: formStatus.mentorenrolmentid,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };

  const validateStep4Input = () => {
    const {
      numberofstartups,
      industry,
      subindustry,
      specialization,
      subspecialization,
      preferredStage,
      disclaimer,
      cohortVisibility
    } = formData;
    const formStatus = FormValidator.validateStep4({
      numberofstartups,
      industry,
      subindustry,
      specialization,
      subspecialization,
      preferredStage,
      disclaimer,
      cohortVisibility
    });

    const errors = {
      numberofstartups: formStatus.numberofstartups,
      industry: formStatus.industry,
      subindustry: formStatus.subindustry,
      specialization: formStatus.specialization,
      subspecialization: formStatus.subspecialization,
      preferredStage: formStatus.preferredStage,
      disclaimer: formStatus.disclaimer,
      cohortVisibility: formStatus.cohortVisibility,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };

  const onBlur = () => {
    if (activeStep === 0) validateStep1Input();
    if (activeStep === 1) validateStep2Input();
    if (activeStep === 2) validateStep3Input(defaultMentorID);
    if (activeStep === 3) validateStep4Input();
    // if (activeStep === 4) validateStep5Input();
  };

  // const Option = (props) => {
  //   return (
  //     <div>
  //       <components.Option {...props}>
  //         <input
  //           type="checkbox"
  //           checked={props.isSelected}
  //           onChange={() => null}
  //         />{" "}
  //         <label>{props.label}</label>
  //       </components.Option>
  //     </div>
  //   );
  // };

  // const allOption = {
  //   label: "Select all",
  //   value: "*",
  // };

  // const ValueContainer = ({ children, ...props }) => {
  //   const currentValues = props.getValue();
  //   let toBeRendered = children;
  //   if (currentValues.some((val) => val.value === allOption.value)) {
  //     toBeRendered = [[children[0][0]], children[1]];
  //   }

  //   return (
  //     <components.ValueContainer {...props}>
  //       {toBeRendered}
  //     </components.ValueContainer>
  //   );
  // };

  // const MultiValue = (props) => {
  //   let labelToBeDisplayed = `${props.data.label}, `;
  //   if (props.data.value === allOption.value) {
  //     labelToBeDisplayed = "All is selected";
  //   }
  //   return (
  //     <components.MultiValue {...props}>
  //       <span>{labelToBeDisplayed}</span>
  //     </components.MultiValue>
  //   );
  // };

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  // const animatedComponents = makeAnimated();

  // Generate JSX code for error message
  const renderErrorMessage = (name) => {
    return (
      <div style={{ paddingLeft: "0px" }}>
        <div className="login-error-msg">{name}</div>
      </div>
    );
  };
  const handleChange = (selected) => {
    setOptionSelected(selected);
  };

  const [cohortstartdate, setCohortstartdate] = useState();
  const [startupstartdate, setStartupstartdate] = useState();
  const [startupenddate, setStartupenddate] = useState();
  let today = new Date().toISOString().slice(0, 10);
  const [presentDate, setPresentDate] = useState(today);
  function getStepContent(step) {
    const oncheckedChange = (e) => {
      setFormData((user) => {
        return { ...user, disclaimer: !formData.disclaimer };
      });
      // setTimeout(() => {
      // validateStep4Input();
      // }, 100);
    };

    const makeMentorEnrolmentId = (e, index) => {
      const { name, value } = e.target;
      const list = formData.mentorenrolmentid;

      // list.push(value);
      list[index] = [value];

      // setFormData((user) => {
      //   return { ...user, [name]: value };
      // });

      // let data = [...mentorEnrolmentIdList];
      // data[index][name] = value;
      setDefaultMentorID(list);
      // setMentorEnrolmentIdList(list);

      let data2 = [];

      list.map((item) => {
        data2.push(item);
      });

      setFormData((user) => {
        return { ...user, ["enrolementIds"]: data2 };
      });

      setMentorEnrolmentIdList2(data2);
    };
    const handleInputChange = (e, index) => {
      // alert(e.target.name)
      // const { value, name } = e.target;
      // // alert(value)
      // setFormData((user) => {
      //   return { ...user, [name]: value };
      // });
      try {
        if (e.target.name === "hoursperweek") {
          setFormData((user) => {
            return { ...user, hoursperweek: e.target.defaultValue };
          });
          // hoursperweek

        }
        if (e.target.name === "uploadAttach") {
          if (e.target.files[0].type == "application/pdf") {
            setFormData((user) => {
              return { ...user, [e.target.name]: e.target.files[0] };
            });
          } else {
            toast.error("File format is not supported");
          }
          // setFormData((user) => {
          //   return { ...user, [e.target.name]: e.target.files[0] };
          // });
        } else if (e.target.name === "uploadLogo") {
          if (
            e.target.files[0].type == "image/png" ||
            e.target.files[0].type == "image/jpeg"
          ) {
            // previewProfilePic(e.target.files[0]);
            // setFormData((user) => {
            //   // return { ...user, [e.target.name]: e.target.files[0] };
            //   return { ...user, uploadLogo: e.target.files[0] };
            // });

            var img = new Image();

            img.src = window.URL.createObjectURL(e.target.files[0]);
            img.onload = function () {
              var width = img.naturalWidth,
                height = img.naturalHeight;

              window.URL.revokeObjectURL(img.src);

              // if (
              //   width >= 600 &&
              //   height < width - 100 &&
              //   (height <= 440 || height >= 380)
              // )
              // if (
              //   (width === 100 && height === 100) ||
              //   (width === 200 && height === 200)
              // ) {
              // previewProfilePic2(e.target.files[0]);
              // setFormData((user) => {
              //   return { ...user, [e.target.name]: e.target.files[0] };
              // });
              previewProfilePic(e.target.files[0]);
              setFormData((user) => {
                // return { ...user, [e.target.name]: e.target.files[0] };
                return { ...user, uploadLogo: e.target.files[0] };
              });
              // } else {
              //   swal({
              //     title: "Upload Other Banner Image",
              //     text: "Image size should be (100 * 100 ) or (200 *200)",
              //     icon: "info",
              //   });
              // }
            };
          } else {
            toast.error("File format is not supported");
          }
        } else if (e.target.name === "uploadBanner") {
          if (
            e.target.files[0].type == "image/png" ||
            e.target.files[0].type == "image/jpeg"
          ) {
            var img = new Image();

            img.src = window.URL.createObjectURL(e.target.files[0]);
            img.onload = function () {
              var width = img.naturalWidth,
                height = img.naturalHeight;

              window.URL.revokeObjectURL(img.src);

              // if (
              //   width >= 600 &&
              //   height < width - 100 &&
              //   (height <= 440 || height >= 380)
              // )
              // if (
              //   width >= 700 &&
              //   width <= 800 &&
              //   height >= 400 &&
              //   height <= 440
              // ) {
              previewProfilePic2(e.target.files[0]);
              setFormData((user) => {
                return { ...user, [e.target.name]: e.target.files[0] };
              });
              // } else {
              //   swal({
              //     title: "Upload Other Banner Image",
              //     text: "Image size should be 790w x 440h pixels",
              //     icon: "info",
              //   });
              // }
            };
          } else {
            toast.error("File format is not supported");
          }
        } else if (e.target.name === "mentorenrolmentid") {
          // const { value, name } = e.target;
          // setFormData((user) => {
          //   return { ...user, [name]: value };
          // });
          // if (value.indexOf(" ") >= 0) {

          //   setFormData((user) => {
          //     return { ...user, ["enrolementIds"]: value };
          //   });
          //   addEntryClick(value);
          //   setFormData((user) => {
          //     return { ...user, [name]: "" };
          //   });
          //   // setFormData(prevState => ({
          //   //   myArray: [...prevState, ["setFormData"new value"]
          //   // }))
          // }
          const { name, value } = e.target;
          const list = [...mentorEnrolmentIdList];
          list[index][name] = value;
          setFormData((user) => {
            return { ...user, [name]: value };
          });

          // let data = [...mentorEnrolmentIdList];
          // data[index][name] = value;
          setMentorEnrolmentIdList(list);

          let data2 = [];

          list.map((item) => {
            data2.push(item.mentorenrolmentid);
          });

          setFormData((user) => {
            return { ...user, ["enrolementIds"]: data2 };
          });

          setMentorEnrolmentIdList2(data2);

          // setMentorEnrolmentIdList(list);
          // setFormData((user) => {
          //   return { ...user, ["enrolementIds"]: list };
          // });
        } else if (e.target.name === "cohort_date") {
          // setNewprogdurnumber(progdurnumber);
          const { value, name } = e.target;
          const cohrotnewdate = new Date(value);
          const cohrotnewdateparsed = cohrotnewdate.toISOString().slice(0, 10);

          setCohortStartDateParsed(cohrotnewdateparsed);
          const tomorrowcohortDate = cohrotnewdate.setDate(
            cohrotnewdate.getDate() - 2
          );

          const latercohortDate = cohrotnewdate.setDate(
            cohrotnewdate.getDate() + 17
          );

          const newdatelatercohortDate = new Date(latercohortDate);

          

          let newTestDate = new Date(value);
          let cohrotnewdate2threemonths = new Date(
            newTestDate.setMonth(
              newTestDate.getMonth() + parseInt(progdurationumber)
              )
            );
                        var maxDate = new Date(cohrotnewdate2threemonths);
            maxDate.setDate(maxDate.getDate() - 1);
            var maxDateNew= moment(maxDate).format('YYYY-MM-DD')
            setCohortEndDateParsed(maxDateNew)
            // let cohrotnewdate2threemonths = new Date(latercohortDate)
            // const cohrotnewdate2threemonths = new Date(
            //   latercohortDate.setMonth(
            //     // cohrotnewdate2.getMonth() + parseInt(progdurationumber)
            //     latercohortDate.getMonth() + parseInt(progdurationumber)
            //   )
            // );
            // var maxDate = new Date(cohrotnewdate2threemonths);
            // maxDate.setDate(maxDate.getDate() - 1);
            // var maxDateNew= moment(maxDate).format('YYYY-MM-DD')
            // setCohortEndDateParsed(maxDateNew)

          // setCohortEndDateParsed(cohortendnewdateparsed);

          const cohortdateFinal = new Date(tomorrowcohortDate);
          const cohortdateFinal2 = new Date(latercohortDate);
          const cohortdateFinalmodified = cohortdateFinal
            .toISOString()
            .slice(0, 10);

          const cohortdateFinalmodified2 = cohortdateFinal2
            .toISOString()
            .slice(0, 10);

          const lesstomorrowcohortDate = cohrotnewdate.setDate(
            cohrotnewdate.getDate() + 2
          );
          const lesscohortdateFinal = new Date(lesstomorrowcohortDate);
          const lesscohortdateFinalmodified = lesscohortdateFinal
            .toISOString()
            .slice(0, 10);

          setModifiedEndDate(lesscohortdateFinalmodified);
          setStartupstartdate(cohortdateFinalmodified);
          setCohortstartdate(lesscohortdateFinalmodified);

          setFormData((user) => {
            return { ...user, [name]: value };
          });
        } else if (e.target.name === "startup_start_date") {
          const { value, name } = e.target;
          const cohrotnewdate = new Date(value);
          const tomorrowcohortDate = cohrotnewdate.setDate(
            cohrotnewdate.getDate() + 1
          );

          const cohortdateFinal = new Date(tomorrowcohortDate);
          const cohortdateFinalmodified = cohortdateFinal
            .toISOString()
            .slice(0, 10);
          setStartupenddate(cohortdateFinalmodified);

          setFormData((user) => {
            return { ...user, [name]: value };
          });
        } else {
          const { value, name } = e.target;
          const cohrotnewdate = new Date(value);

          setFormData((user) => {
            return { ...user, [name]: value };
          });
        }
      } catch (error) {}
    };
    const { ValueContainer, Placeholder } = components;

    const CustomValueContainer = ({ children, ...props }) => {
      return (
        <ValueContainer {...props}>
          <Placeholder {...props} isFocused={props.isFocused}>
            {props.selectProps.placeholder}
          </Placeholder>
          {React.Children.map(children, (child) =>
            child && child.key !== "placeholder" ? child : null
          )}
        </ValueContainer>
      );
    };

    const handleInputChange1 = (e, index) => {
      const { name, value } = e.target;
      const list = [...mentorEnrolmentIdList];
      list[index][name] = value;
      setMentorEnrolmentIdList(list);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index) => {
      // i.preventDefault();
      const list = [...mentorEnrolmentIdList];
      list.splice(index, 1);
      setMentorEnrolmentIdList(list);

      let data2 = [];

      list.map((item) => {
        data2.push(item.mentorenrolmentid);
      });

      setMentorEnrolmentIdList2(data2);
    };

    // handle click event of the Add button
    const handleAddClick = () => {
      setMentorEnrolmentIdList([
        ...mentorEnrolmentIdList,
        { mentorenrolmentid: "" },
      ]);
    };
    const handleAddClick2 = () => {
      setDefaultMentorID((current) => [...current, [""]]);
      setFormData((user) => {
        return {
          ...user,
          mentorenrolmentid: defaultMentorID,
        };
      });
    };
    // handle click event of the Remove button

    switch (step) {
      case 0:
        return (
          <>
            <div
              className="cohortformsteps row"
              style={{ paddingBottom: "10px" }}
            >
              {/* <InputField
                id="full_name"
                label="Full Name"
                variant="outlined"
                // placeholder="Enter Your First Name"
                fullWidth
                margin="normal"
                name="full_name"
                className="col-12"
                onChange={handleInputChange}
                defaultValue={formData.full_name}
              /> */}

              <InputField
                // disabled={
                //   loginDataJson.applicationStatus === "VERIFIED" &&
                //   !localStorage.getItem("path")
                //     ? true
                //     : false
                // }
                required={true}
                id="mentor_name"
                label="Name of Mentor"
                variant="outlined"
                // placeholder="Type Here.."
                fullWidth
                margin="normal"
                onChange={handleInputChange}
                value={formData.mentor_name}
                name="mentor_name"
                error={error.mentorname}
                onBlur={onBlur}
                disabled={true}
                // disabled={
                //   history?.location?.state?.mode === "edit" || history?.location?.state?.mode === "create"
                //     ? true
                //     : false
                // }
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                // inputProps={{
                //   style:{backgroundColor:"white"}
                // }}
              />
              {/* <GlobalDropDown
                required={true}
                id="gender"
                label="Gender *"
                variant="outlined"
                fullWidth
                margin="normal"
                name="gender"
                className="col-12"
                // style={{marginBottom:"5px"}}
                onChange={handleInputChange}
                value={formData.gender}
                option={genders}
                // type="Gender"
                // error={error.gender}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
               
              /> */}
              {/* <Select
                required={true}
                id="gender"
                // label="Gender*"
                variant="outlined"
                fullWidth
                margin="normal"
                name="gender"
                className="col-12 gendercohortinput"
                styles={customStyles}
                value={formData.gender}
                // defaultValue={genderOption}
                // onChange={handleInputChange}
                onChange={(e) => {
                  // setGender(e.value);
                  setFormData((user) => {
                    return { ...user, gender: e };
                  });
                }}
                options={genders}
                onBlur={onBlur}
                placeholder="Gender*"
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              {error.gender && renderErrorMessage(error.gender)} */}
              {/* <div className="formfileuploaddiv">
                <FileUpload />
              </div> */}
              <InputField
                // disabled={
                //   loginDataJson.applicationStatus === "VERIFIED" &&
                //   !localStorage.getItem("path")
                //     ? true
                //     : false
                // }
                required={true}
                id="organization_name"
                label="Name of Organization"
                variant="outlined"
                // placeholder="Enter Your Address 1"
                fullWidth
                margin="normal"
                name="organization_name"
                className="col-12"
                onChange={handleInputChange}
                value={formData.organization_name}
                error={error.organizationname}
                onBlur={onBlur}
                // disabled={history?.location?.state?.mode ==="edit" ? true:false}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ maxLength: 150, }}
                // inputProps={{
                //   style:{backgroundColor:"white",maxLength: 150}
                // }}
              />
              <div className="file_upload">
                <div>
                  <div className="rowC ">
                    <div className="col-md-9" onChange={handleInputChange}>
                      <p class="upload-mentor-text">UPLOAD LOGO (OPTIONAL)</p>
                      <p
                        className="bannerRelatedImg"
                        style={{ textAlign: "left" }}
                      >
                        <br />
                        <span
                          className="supported-file fileuptomb"
                          style={{ position: "inherit" }}
                        >
                          Supported file format jpeg , png only upto 500KB
                        </span>
                        <br />
                        <span
                          className="supported-file"
                          style={{ position: "inherit" }}
                        >
                          (Recommended Dimensions are (100 * 100) or (200 * 200)
                          pixels)
                        </span>
                      </p>
                    </div>
                    <img
                      id="fileUpload-profile-pic"
                      src={
                        formData.uploadLogo?.name !== null &&
                        formData.uploadLogo?.name !== undefined
                          ? previewProfilePic(formData && formData.uploadLogo)
                          : formData.uploadLogo !== null
                          ? formData.uploadLogo
                          : hashImage
                      }
                      //  src={
                      //   formData.uploadLogo === null
                      //     ? typeof(formData.uploadLogo) === "object" ? previewProfilePic(formData && formData.uploadLogo) :
                      //       hashImage
                      //     : formData.uploadLogo
                      // }
                      // src={
                      //   formData.uploadLogo === null
                      //     ? // ? previewProfilePic(formData && formData.uploadLogo)
                      //       hashImage
                      //     : formData.uploadLogo
                      // }
                      className={
                        history?.location?.state?.mode === "create" &&
                        formData.uploadLogo === undefined
                          ? "col-md-3 logoOfimage"
                          : "col-md-3 logoOfimage02"
                      }
                    />
                  </div>
                  {/* <p className="upload-mentor-text">
                    Upload Program Logo
                    <span>
                      Supported file format jpeg , png only upto 500KB
                    </span>
                  </p> */}

                  {/* <img id="blah" alt="your image" style={{"width":"100px", "height":"100px" }}/> */}
                  <input
                    // disabled={
                    //   loginDataJson.applicationStatus === "VERIFIED" &&
                    //   !localStorage.getItem("path")
                    //     ? true
                    //     : false
                    // }
                    className={
                      history?.location?.state?.mode === "create"
                        ? "logo-upload21"
                        : "logo-upload22"
                    }
                    // className="logo-upload"
                    type="file"
                    // name="Upload Document"
                    id="fileUpload-logo"
                    name="uploadLogo"
                    accept="image/*"
                    // accept="application/pdf, application/vnd.ms-excel"
                    onChange={handleInputChange}
                    onBlur={onBlur}
                    // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                  />
                </div>
              </div>
              <span
                class="d-inline-block multiselectorspan  selectComp"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
                // style={{
                //   paddingTop: "5px",
                // }}
              >
                <div
                  style={{
                    paddingTop: "15px",
                    marginTop: "5px",
                    paddingBottom: "0",
                    color: "gray",
                    textAlign: "left",
                    fontSize: "16px",
                    fontFamily: "Montserrat",

                    paddingLeft: "5px",
                  }}
                >
                  Type Of Organization *
                </div>
                <Select
                  // isDisabled={
                  //   history?.location?.state?.mode === "edit" ? true : false
                  // }
                  required={true}
                  id="organization_type"
                  // label="Gender*"
                  // variant="outlined"
                  fullWidth
                  margin="normal"
                  name="organization_type"
                  className="col-12 genderstartupinput"
                  // styles={customStyles}
                  styles={customStylesCountry}
                  // value={formData.organization_type}
                  // defaultValue={genderOption}
                  // onChange={handleInputChange}
                  onChange={(v) =>
                    setFormData((user) => {
                      setTypeDefault(v);
                      return { ...user, organization_type: v.value };
                    })
                  }
                  maxMenuHeight={300}
                  // onFocus={() => setGenderFocused(true)}
                  onBlur={() => setGenderFocused(false)}
                  // isFocused={genderfocused}
                  // placeholder="My Cool Label and work Focused"
                  // isClearable
                  // components={{
                  //   ValueContainer: CustomValueContainer,
                  // }}
                  options={organizationtypeOptions}
                  // onBlur={onBlur}
                  placeholder="Orgnisation Type"
                  // onBlur={onBlur}
                  value={typeDefault}
                  //   value={
                  //     typeDefault.length > 0 ? typeDefault.map(ele => ele) : formData.organization_type
                  // }
                  hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                />
                {/* <MultiselectorComp
                  options={organizationtypeOptions}
                  // isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Select"
                  // placeholder="Type of Organization *"
                  styles={customStyles}
                  // error={error.organization_type}
                  onBlur={onBlur}
                  // onChange={(v) => setOrganizationType(v)}
                  // allowSelectAll={true}
                  // value={organizationType}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(v) =>
                    setFormData((user) => {
                      return { ...user, organization_type: v };
                    })
                  }
                  value={formData.organization_type}
                /> */}
              </span>
              {error.organization_type &&
                renderErrorMessage(error.organization_type)}
              {/* <InputField
                id="current_designation"
                label="Current Designation"
                variant="outlined"
                // placeholder="Enter Your Address 2"
                fullWidth
                margin="normal"
                name="current_designation"
                className="col-12"
                onChange={handleInputChange}
                value={formData.current_designation}
              /> */}
              {/* <TextField
                id="industry"
                label="Industry"
                variant="outlined"
                // placeholder="Enter Your Last Name"
                fullWidth
                margin="normal"
                name="industry"
                className="col-12"
                select
               
              /> */}
              {/* <Select
              //  value={this.state.value}
              //  onChange={this.handleChange.bind(this)}
              >
                {names.map((name) => (
                  <MenuItem key={name.id} value={name.id}>
                    <ListItemText primary={name.value} />
                  </MenuItem>
                ))}
              </Select> */}
              {/* <Select
                options={options}
                isMulti
                placeholder="Industry (multiple selections upto 5"
                value={tags}
                onChange={(v) => (v.length < 6 ? setTags(v) : null)}
              /> */}
              {/* <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <MultiselectorComp
                  options={colourOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Industry (multiple selections upto 5)"
                  styles={customStyles}
                  
                  onChange={(v) => (v.length < 6 ? setIndustry(v) : null)}
                  // allowSelectAll={true}
                  value={industry}
                />
              </span>

            
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <MultiselectorComp
                  options={specializationOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Specialization (multiple selections upto 3)"
                  styles={customStyles}
                 

                  onChange={(v) => (v.length < 4 ? setSpecialization(v) : null)}
                  // allowSelectAll={true}
                  value={specialization}
                />
              </span>
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <MultiselectorComp
                  options={preferredOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Preferred stage of the startup"
                  styles={customStyles}
                 

                  onChange={(v) => (v.length < 4 ? setPreferredStage(v) : null)}
                  // allowSelectAll={true}
                  value={preferredStage}
                />
              </span> */}
            </div>
          </>
        );

      case 1:
        return (
          <>
            <div className="cohortformsteps row">
              <InputField
                // disabled={
                //   loginDataJson.applicationStatus === "VERIFIED" &&
                //   !localStorage.getItem("path")
                //     ? true
                //     : false
                // }
                required={true}
                id="program_name"
                label="Name of The Program"
                variant="outlined"
                // placeholder="Enter Your E-mail Address"
                fullWidth
                margin="normal"
                name="program_name"
                className="col-12"
                onChange={handleInputChange}
                value={formData.program_name ? formData.program_name : ""}
                error={error.programname}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ maxLength: 100 }}
                // inputProps={{
                //   style:{backgroundColor:"white",maxLength: 100}
                // }}
              />

              <InputField
                required={true}
                id="program_desc"
                // label="Description of Program (upto 250 words)"
                label={
                  windowSize.innerWidth <= 414
                    ? "Description of Program"
                    : "Description of Program (upto 250 words)"
                }
                variant="outlined"
                // placeholder="Enter Your E-mail Address"
                fullWidth
                margin="normal"
                name="program_desc"
                multiline={true}
                rows={2}
                maxRows={4}
                className="col-12"
                onChange={(e, name) => {
                  // if (testWordLimit(e.target.value) < 100) {
                  //   handleInputChange(e, name);
                  // }
                  const value = e.target.value;
                  // const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
                  const newerData = value.replace(/[ ]{2,}/gi, " ");
                  if (
                    newerData.split(" ").length <= 251 &&
                    testWordLimit(newerData) < 251
                  ) {
                    handleInputChange(e, name);
                    setFormData((user) => {
                      return { ...user, program_desc: newerData };
                    });
                  }

                  setWordlimit(newerData);
                }}
                // onChange={handleInputChange}
                value={formData.program_desc}
                error={error.programdesc}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //   style:{backgroundColor:"white"}
                // }}
                // inputProps={{ maxLength: 300 }}
              />
              <div
                className="wordCounter"
                style={{
                  fontWeight: "bold",
                  textAlign: "right",
                  marginTop: "-10px",
                  marginBottom: "7px",
                }}
              >
                Word Count:{" "}
                {formData.program_desc?.length === 0
                  ? 0
                  : wordLimit?.length === 0
                  ? 0
                  : formData.program_desc
                      ?.replace(/(^\s*)|(\s*$)/gi, "")
                      ?.replace(/[ ]{2,}/gi, " ")
                      ?.split(" ")?.length}{" "}
                / 250
              </div>
              {errorVisible7 ? renderErrorMessage(errorMessagePurpose) : ""}

              {/* <div className="formfileuploaddiv">
                <FileUpload />
              </div> */}
              {/* <div className="file_upload">
                <div>
                  <div className="rowC ">
                    <div className="col-md-9">
                      <p class="upload-mentor-text">UPLOAD LOGO (OPTIONAL)</p>
                      <p style={{ textAlign: "left" }}>
                        <br />
                        <span
                          className="supported-file"
                          style={{ position: "inherit" }}
                        >
                          Supported file format jpeg , png only upto 500KB
                        </span>
                      </p>
                    </div>
                    <img
                      className="col-md-3"
                      id="fileUpload-profile-pic"
                      src={
                        formData.uploadLogo
                          ? previewProfilePic(formData && formData.uploadLogo)
                          : profileExistingImg
                      }
                      style={{
                        width: "100px",
                        marginLeft: "15px",
                        marginTop: "5px",
                        height: "60px",
                      }}
                    />
                  </div>
                  
                  <input
                    className="logo-upload"
                    type="file"
                    // name="Upload Document"
                    id="fileUpload-logo"
                    name="uploadLogo"
                    accept="image/*"
                    // accept="application/pdf, application/vnd.ms-excel"
                    onChange={handleInputChange}
                    onBlur={onBlur}
                    // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                  />
                </div>
              </div> */}

              <div
                className="file_upload_cohort"
                style={{ marginBottom: "10px" }}
              >
                <div>
                  <div className="rowC ">
                    <div className="col-md-9">
                      <p class="upload-mentor-text">UPLOAD BANNER IMAGE*</p>
                      <p
                        className="bannerRelatedImg"
                        style={{ textAlign: "left" }}
                      >
                        <br />
                        <span
                          className="supported-file fileuptomb"
                          style={{ position: "inherit", width: "100px" }}
                        >
                          Supported file format jpeg , png only upto 2MB
                        </span>
                        <br />
                        <span
                          className="supported-file"
                          style={{ position: "inherit" }}
                        >
                          (Recommended Dimensions : 790w X 440h pixels)
                        </span>
                      </p>
                    </div>
                    <img
                      className="col-md-3 loadedprofilepic cohortprofilrImg"
                      id="fileUpload-profile-pic2"
                      style={
                        history?.location?.state?.mode === "create" &&
                        formData.uploadBanner === undefined
                          ? { display: "none" }
                          : { display: "block" }
                      }
                      // src={
                      //   formData.uploadBanner
                      //     ? previewProfilePic2(
                      //         formData && formData.uploadBanner
                      //       )
                      //     : bannerExistingImg
                      // }
                      src={
                        formData.uploadBanner?.name !== null &&
                        formData.uploadBanner?.name !== undefined
                          ? previewProfilePic2(
                              formData && formData.uploadBanner
                            )
                          : formData.uploadBanner !== null
                          ? formData.uploadBanner
                          : hashImage
                      }
                      // src={
                      //   formData.uploadBanner === null
                      //     ? hashImage
                      //     : formData.uploadBanner
                      // }
                    />
                  </div>
                  {/* <p className="upload-mentor-text">
                    Upload Program Logo
                    <span>
                      Supported file format jpeg , png only upto 500KB
                    </span>
                  </p> */}

                  {/* <img id="blah" alt="your image" style={{"width":"100px", "height":"100px" }}/> */}
                  <input
                    ref={imgRef}
                    className={
                      history?.location?.state?.mode === "create"
                        ? "logo-upload23"
                        : "logo-upload24"
                    }
                    type="file"
                    // name="Upload Document"
                    id="fileUpload-banner"
                    name={"uploadBanner"}
                    accept="image/*"
                    // accept="application/pdf, application/vnd.ms-excel"

                    onChange={handleInputChange}
                    onBlur={onBlur}
                    // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
                  />
                </div>
              </div>
              {bannerExistingImg === null ||
              bannerExistingImg === "" ||
              bannerExistingImg === undefined
                ? error.uploadBanner && renderErrorMessage(error.uploadBanner)
                : ""}
              <div style={{display:"flex",margin:"0",padding:"0"}}>
                <div style={{width:"50%"}}> 
              <InputField
                id="program_duration"
                label={
                  windowSize.innerWidth <= 414
                    ? "Duration of The Program "
                    : "Duration of The Program (minimum 3 months) "
                }
                variant="outlined"
                // placeholder="Enter Your Phone Number"
                fullWidth
                margin="normal"
                name="program_duration"
                className="col-6 program_durationCohort"
                // inputProps={{
                //   style: { padding: 0 }
                // }}
                type="text"
                onKeyDown={(evt) =>
                  (["e", "E", "+", "-"].includes(evt.key) &&
                    evt.preventDefault()) ||
                  ([
                    "A",
                    "B",
                    "C",
                    "D",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                  ].includes(evt.key) &&
                    evt.preventDefault()) ||
                  ([
                    "a",
                    "b",
                    "c",
                    "d",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                  ].includes(evt.key) &&
                    evt.preventDefault())
                }
                onChange={(e, name) => {
                  const value = e.target.value;
                  handleInputChange(e, name);
                  setFormData((user) => {
                                      
                    // return { ...user, [e.target.name]: e.target.files[0] };
                    return { ...user , infiniteDuration: false };
                  });
                  setInfiniteDuration(false)

                  setNewprogdurnumber(value);
                  let newTestDate = new Date(formData.cohort_date);
                  let cohrotnewdate2threemonths = new Date(
                    newTestDate.setMonth(
                      newTestDate.getMonth() + parseInt(progdurationumber)
                      )
                    );
                                var maxDate = new Date(cohrotnewdate2threemonths);
                    maxDate.setDate(maxDate.getDate() - 1);
                    var maxDateNew= moment(maxDate).format('YYYY-MM-DD')
                    setCohortEndDateParsed(maxDateNew)
                }}
                // error={error.program_duration}
                inputProps={{ maxLength: 2,fontSize:10 }}
                // inputProps={{
                //   style:{backgroundColor:"white",maxLength: 2,fontSize:10}
                // }}
                InputLabelProps={{ maxLength: 2,fontSize:10}}
                // InputLabelProps={{
                //   shrink: true,

                value={formData.program_duration}
                onBlur={onBlur}
                // disabled={infiniteDuration}
              />
              {windowSize.innerWidth <= 414 ? (
                <div
                  className="wordCounter"
                  style={{
                    fontWeight: "bold",
                    textAlign: "right",
                    marginTop: "-10px",
                    marginBottom: "7px",
                  }}
                >
                  Minimum 3 months
                </div>
              ) : (
                ""
              )}</div>
               <div className="cohortTypeDuration">
                <div>
                  Or
                </div>
                <div className="d-flex" style={{gap:"5px",marginLeft:"1.5rem"}}>
                          <div>
                                <input
                                  type="checkbox"
                                  className="cohortCheckBox"
                                  name="cohortTimeCheck"
                                  style={{minHeight:"1.65rem"}}
                                  checked={infiniteDuration}
                                  onClick={(e)=>{
                                    setInfiniteDuration(!infiniteDuration)
                                    setFormData((user) => {
                                      
                                      // return { ...user, [e.target.name]: e.target.files[0] };
                                      return { ...user,program_duration:"" , infiniteDuration: !infiniteDuration };
                                    });
                                  }}
                                  onBlur={onBlur}
                                  // checked={item?.spotlight}
                                  // onClick={(e) =>
                                  //   spotLightFn(item, !item?.spotlight)
                                  // }
                                />
                                </div>
                                <h6 className="homepageSecondDescription">
                                  No end date
                                </h6>
                              </div>
                              </div>
              </div>
              <div style={{margin:"0",padding:"0"}}>
                <h6>
                  Please choose either of the options for program duration*
                </h6>
              </div>
             
             <span style={{margin:"0",padding:"0",marginTop:"0.5rem"}}>
              {error.program_duration &&
                renderErrorMessage(error.program_duration)}
                </span>
              <Grid
                item
                container
                // spacing={2}
                xs={12}
                style={{
                  paddingBottom: "10px",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                }}
              ></Grid>
              {history?.location?.state?.fromPage !== "cohort-application" &&
                history?.location?.state?.fromPage !== "cohort-program" &&
                history?.location?.state?.data?.applicationStatus ===
                  "VERIFIED" && (
                  <>
                    <Grid
                      item
                      container
                      // spacing={2}

                      xs={12}
                      style={{ paddingLeft: "0px", paddingRight: "0px" }}
                    >
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        style={{
                          paddingRight: "5px",
                        }}
                      >
                        <h6
                          style={{
                            fontFamily: "Montserrat",
                            fontSize: "16px",
                            width: "100%",
                            padding: "5px 10px 0 3px",
                            fontWeight: "300",
                            color: "#6e6e6e",
                            margin: "5px 0px 5px 0px",
                          }}
                        >
                          {`Cohort Start Date${
                            history?.location?.state?.mode === "edit" &&
                            history?.location?.state?.data
                              ?.applicationStatus === "VERIFIED"
                              ? "*"
                              : ""
                          }`}
                        </h6>

                        <Box
                          style={{
                            border: "1px solid rgba(0,0,0,0.3)",
                            borderRadius: "4px",
                            display: "flex",

                            // padding: "5px 10px",
                          }}
                        >
                         
                          {/* {moment(datum?.applicationDate).format("DD/MM/YYYY")}
                  <br/>

                  {moment(datum?.applicationDate).format("hh:mm")} */}
                          <InputBase
                            className={
                              history?.location?.state?.mode === "edit" &&
                              history?.location?.state?.data
                                ?.applicationStatus === "VERIFIED"
                                ? ""
                                : "cohortstartdatedraftview"
                            }
                            // disabled={
                            //   history?.location?.state?.mode === "edit" &&
                            //   history?.location?.state?.data
                            //     ?.applicationStatus === "VERIFIED"
                            //     ? presentDate01 > formData.cohort_date || presentDate01 == formData?.cohort_date ? true : false
                            //     : true
                            // }
                            // disabled={
                            //   loginDataJson.applicationStatus === "VERIFIED" &&
                            //   !localStorage.getItem("path")
                            //     ? true
                            //     : false
                            // }
                            // label="DD/MM/YYYY"
                            inputProps={{
                              min: new Date()?.toISOString().slice(0, 10),
                              // min: tomorrowDateFinal.toISOString().slice(0, 10),
                              // min: cohortStartDateParsed,
                            }}
                            type="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            style={{
                              fontFamily: "Montserrat",
                              // fontWeight: "no",
                              fontSize: "16px",
                              color: "rgba(0,0,0,0.5)",
                              width: "100%",
                              padding: "5px 10px",
                            }}
                            name="cohort_date"
                            value={formData.cohort_date}
                            // onChange={(e) => {
                            //   setCohortDate(e.target.value);

                            onBlur={onBlur}
                            // }}
                            onChange={handleInputChange}
                            // placeholder={(props?.modalData?.sessionDate !== undefined ) ? moment(props?.modalData.sessionDate).format("DD/MM/YYYY") : "DD/MM/YYYY" }
                          />
                        </Box>
                        {history?.location?.state?.mode === "edit" &&
                        history?.location?.state?.data?.applicationStatus ===
                          "VERIFIED"
                          ? error.cohort_date &&
                            renderErrorMessage(error.cohort_date)
                          : ""}
                        {/* {error.cohort_date && renderErrorMessage(error.cohort_date)} */}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        style={{
                          paddingRight: "5px",
                        }}
                      >
                        {/* {history?.location?.state?.mode === "create" ? ( */}
                        <div className="linearformtooltip">
                          <div
                            className="tooltipicon"
                            style={{ cursor: "pointer" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-info-circle"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                            </svg>
                            <span className="tooltiptext7">
                              Cohort start Date , Startup Application Start Date
                              and Startup Application Start Date automatically
                              filled once admin approved this cohort, later you
                              can edit
                            </span>{" "}
                          </div>
                        </div>
                        {/* ) : (
                    ""
                  )} */}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      // spacing={2}

                      xs={12}
                      style={{ paddingLeft: "0px", paddingRight: "0px" }}
                    >
                      {/* <h6 style={{ paddingLeft: "10px" }}>
                  STARTUP APPLICATION START & END DATE
                </h6> */}
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        style={{
                          paddingRight: "5px",
                        }}
                      >
                        <h6
                          style={{
                            fontFamily: "Montserrat",
                            fontSize: "16px",
                            width: "100%",
                            padding: "5px 10px 0 3px",
                            fontWeight: "300",
                            color: "#6e6e6e",
                            margin: "5px 0px 5px 0px",
                          }}
                        >
                          {`Startup Application Start Date${
                            history?.location?.state?.mode === "edit" &&
                            history?.location?.state?.data
                              ?.applicationStatus === "VERIFIED"
                              ? "*"
                              : ""
                          }`}
                        </h6>
                        <Box
                          style={{
                            border: "1px solid rgba(0,0,0,0.3)",
                            borderRadius: "4px",
                            display: "flex",
                            padding: "5px 10px",
                          }}
                        >
                          {/* {moment(datum?.applicationDate).format("DD/MM/YYYY")}
                  <br/>

                  {moment(datum?.applicationDate).format("hh:mm")} */}
                          <InputBase
                            className={
                              history?.location?.state?.mode === "edit" &&
                              history?.location?.state?.data
                                ?.applicationStatus === "VERIFIED"
                                ? ""
                                : "cohortstartdatedraftview"
                            }
                            // disabled={
                            //   history?.location?.state?.data
                            //     ?.applicationStatus === "VERIFIED"
                            //     ? false
                            //     : true
                            // }

                            // disabled={
                            //   history?.location?.state?.mode === "edit" &&
                            //   history?.location?.state?.data
                            //     ?.applicationStatus === "VERIFIED"
                            //     ? presentDate01 > formData.startup_start_date  || presentDate01 == formData?.startup_start_date ? true : false
                            //     : true
                            // }
                            // label="DD/MM/YYYY"
                            // inputProps={{
                            //   // min: new Date().toISOString().slice(0, 10),
                            //   min: startupstartdate,
                            //   // min:tomorrowDateFinal.toISOString().slice(0, 10)
                            // }}
                            type="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              min: new Date().toISOString().split('T')[0],
                              max: formData.cohort_date,
                              // max: cohortstartupstartdate.toISOString().slice(0, 10),
                            }}
                            style={{
                              fontFamily: "Montserrat",
                              // fontWeight: "bold",
                              fontSize: "16px",
                              color: "rgba(0,0,0,0.5)",
                              width: "100%",
                            }}
                            value={formData.startup_start_date}
                            name="startup_start_date"
                            onBlur={onBlur}
                            // onChange={(e) => {
                            //   setDate(e.target.value);
                            //   // setTimeError(null);
                            //   // setError(null);
                            // }}
                            onChange={handleInputChange}
                            // placeholder={(props?.modalData?.sessionDate !== undefined ) ? moment(props?.modalData.sessionDate).format("DD/MM/YYYY") : "DD/MM/YYYY" }
                          />
                        </Box>
                        {history?.location?.state?.mode === "edit" &&
                        history?.location?.state?.data?.applicationStatus ===
                          "VERIFIED"
                          ? error.startup_start_date &&
                            renderErrorMessage(error.startup_start_date)
                          : ""}
                        {/* {error.startup_start_date &&
                    renderErrorMessage(error.startup_start_date)} */}
                      </Grid>
                      {
                        // true &&
                        !infiniteDuration &&
                        <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                        style={{
                          paddingLeft: "5px",
                        }}
                      >
                        <h6
                          className="startupapplicationenddate"
                          style={{
                            fontFamily: "Montserrat",
                            fontSize: "16px",
                            width: "100%",

                            fontWeight: "300",
                            color: "#6e6e6e",
                            margin: "2px 0px 5px 0px",
                          }}
                        >
                          {`Deadline for Startup Applications${
                            history?.location?.state?.mode === "edit" &&
                            history?.location?.state?.data
                              ?.applicationStatus === "VERIFIED"
                              ? "*"
                              : ""
                          }`}
                        </h6>
                        <Box
                          style={{
                            border: "1px solid rgba(0,0,0,0.3)",
                            borderRadius: "4px",
                            display: "flex",
                            padding: "5px 10px",
                          }}
                        >
                          {/* {moment(datum?.applicationDate).format("DD/MM/YYYY")}
                  <br/>

                  {moment(datum?.applicationDate).format("hh:mm")} */}
                          <InputBase
                            className={
                              history?.location?.state?.mode === "edit" &&
                              history?.location?.state?.data
                                ?.applicationStatus === "VERIFIED"
                                ? ""
                                : "cohortstartdatedraftview"
                            }
                            disabled={
                              history?.location?.state?.mode === "edit" &&
                              history?.location?.state?.data
                                ?.applicationStatus === "VERIFIED"
                                ? false
                                : true
                            }
                            // disabled={
                            //   history?.location?.state?.data
                            //     ?.applicationStatus === "VERIFIED"
                            //     ? false
                            //     : true
                            // }
                            //  placeholder="DD/MM/YYYY"

                            type="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              // min: cohortStartDateParsed,
                              min: new Date().toISOString().split('T')[0],
                              // ? cohortStartDateParsed
                              // : formData.startup_start_date
                              // max: formData.cohort_date,
                              // max: modifiedEndDate,
                              max: cohortEndDateParsed,
                            }}
                            style={{
                              fontFamily: "Montserrat",
                              // fontWeight: "bold",
                              fontSize: "16px",
                              color: "rgba(0,0,0,0.5)",
                              width: "100%",
                            }}
                            value={formData.startup_end_date}
                            name="startup_end_date"
                            onBlur={onBlur}
                            // onChange={(e) => {
                            //   setDate2(e.target.value);
                            //   // setTimeError(null);
                            //   // setError(null);
                            // }}
                            onChange={handleInputChange}
                            // placeholder={(props?.modalData?.sessionDate !== undefined ) ? moment(props?.modalData.sessionDate).format("DD/MM/YYYY") : "DD/MM/YYYY" }
                          />
                        </Box>
                      
                        {history?.location?.state?.mode === "edit" &&
                        history?.location?.state?.data?.applicationStatus ===
                          "VERIFIED"
                          ? error.startup_end_date &&
                            renderErrorMessage(error.startup_end_date)
                          : ""}
                        {/* {error.startup_end_date &&
                    renderErrorMessage(error.startup_end_date)} */}
                      </Grid>
                      }
                 
                    </Grid>
                  </>
                )}
            </div>
          </>
        );
      // case 2:
      //   return (
      //     <>
      //       <div className="cohortformsteps row">
      //         <h6 className="homepageSecondDescription">
      //           Estimated Weekly Session Lengths (Hours) *
      //         </h6>
      //         <InputField
      //           required={true}
      //           id="hoursperweek"
      //           // label="How many average hours can you dedicate for providing mentorship per week?"
      //           variant="outlined"
      //           onKeyDown={(evt) =>
      //             (["e", "E", "+", "-"].includes(evt.key) &&
      //               evt.preventDefault()) ||
      //             ([
      //               "A",
      //               "B",
      //               "C",
      //               "D",
      //               "F",
      //               "G",
      //               "H",
      //               "I",
      //               "J",
      //               "K",
      //               "L",
      //               "M",
      //               "N",
      //               "O",
      //               "P",
      //               "Q",
      //               "R",
      //               "S",
      //               "T",
      //               "U",
      //               "V",
      //               "W",
      //               "X",
      //               "Y",
      //               "Z",
      //             ].includes(evt.key) &&
      //               evt.preventDefault()) ||
      //             ([
      //               "a",
      //               "b",
      //               "c",
      //               "d",
      //               "f",
      //               "g",
      //               "h",
      //               "i",
      //               "j",
      //               "k",
      //               "l",
      //               "m",
      //               "n",
      //               "o",
      //               "p",
      //               "q",
      //               "r",
      //               "s",
      //               "t",
      //               "u",
      //               "v",
      //               "w",
      //               "x",
      //               "y",
      //               "z",
      //             ].includes(evt.key) &&
      //               evt.preventDefault())
      //           }
      //           // placeholder="Average Mentorship Hours Per Week to be spent"
      //           placeholder="Type Here.."
      //           fullWidth
      //           type="text"
      //           margin="normal"
      //           name="hoursperweek"
      //           className="col-12"
      //           onChange={handleInputChange}
      //           value={formData.hoursperweek}
      //           error={error.hoursperweek}
      //           onBlur={onBlur}
      //           InputLabelProps={{
      //             shrink: true,
      //           }}
      //           inputProps={{ maxLength: 3 }}
      //           hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
      //         />
      //         <h6 className="homepageSecondDescription">
      //           Number of Mentors *(Minimum Limit 2)
      //         </h6>
      //         <InputField
      //           required={true}
      //           id="numberofmentors"
      //           onKeyDown={(evt) =>
      //             (["e", "E", "+", "-"].includes(evt.key) &&
      //               evt.preventDefault()) ||
      //             ([
      //               "A",
      //               "B",
      //               "C",
      //               "D",
      //               "F",
      //               "G",
      //               "H",
      //               "I",
      //               "J",
      //               "K",
      //               "L",
      //               "M",
      //               "N",
      //               "O",
      //               "P",
      //               "Q",
      //               "R",
      //               "S",
      //               "T",
      //               "U",
      //               "V",
      //               "W",
      //               "X",
      //               "Y",
      //               "Z",
      //             ].includes(evt.key) &&
      //               evt.preventDefault()) ||
      //             ([
      //               "a",
      //               "b",
      //               "c",
      //               "d",
      //               "f",
      //               "g",
      //               "h",
      //               "i",
      //               "j",
      //               "k",
      //               "l",
      //               "m",
      //               "n",
      //               "o",
      //               "p",
      //               "q",
      //               "r",
      //               "s",
      //               "t",
      //               "u",
      //               "v",
      //               "w",
      //               "x",
      //               "y",
      //               "z",
      //             ].includes(evt.key) &&
      //               evt.preventDefault())
      //           }
      //           // label="How many average hours can you dedicate for providing mentorship per week?"
      //           variant="outlined"
      //           // placeholder="Number of Mentors"
      //           placeholder="Type Here.."
      //           fullWidth
      //           type="text"
      //           margin="normal"
      //           name="numberofmentors"
      //           className="col-12"
      //           onChange={handleInputChange}
      //           value={formData.numberofmentors}
      //           error={error.numberofmentors}
      //           onBlur={onBlur}
      //           // onInput={(e) => {
      //           //   e.target.value = Math.max(0, parseInt(e.target.value))
      //           //     .toString()
      //           //     .slice(0, 4);
      //           // }}
      //           InputLabelProps={{
      //             shrink: true,
      //           }}
      //           inputProps={{ maxLength: 3 }}
      //           hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
      //         />

      //         <span
      //           class="d-inline-block multiselectorspan"
      //           data-toggle="popover"
      //           data-trigger="focus"
      //           data-content="Please selecet account(s)"
      //         >
      //           <h6 className="homepageSecondDescription">
      //             Proposed Mentors to the Cohort(Please Enter Mentor ID) *
      //           </h6>
      //           <MultiselectorComp
      //             // options={industryOptions}
      //             options={
      //               // getPredefineOptions && getPredefineOptions.industry_options
      //               nameListValue.length > 0 ? nameListValue : ""
      //             }
      //             isMulti
      //             closeMenuOnSelect={false}
      //             hideSelectedOptions={false}
      //             placeholder="Enrolment Id"
      //             styles={customStyles}
      //             // onChange={(v) => (v.length < 6 ? setIndustry(v) : null)}
      //             // // allowSelectAll={true}
      //             // value={industry}

      //             onChange={(list) => {
      //               list.length <= formData.numberofmentors
      //                 ? setFormData((user) => {
      //                     let arr = list.filter(function (item) {
      //                       return item.value !== "Select";
      //                     });
      //                     // let arr2 = newenarraynew.filter(function (item) {
      //                     //   return item.value !== "Select";
      //                     // });

      //                     // const newconcatarray = arr.concat(arr2);

      //                     // const nodupnewconcatarray = newconcatarray.filter(
      //                     //   (value, index, self) =>
      //                     //     index ===
      //                     //     self.findIndex(
      //                     //       (t) =>
      //                     //         t.label.slice(-11) === value.label.slice(-11)
      //                     //     )
      //                     // );

      //                     // const testudnefiendvalue = "M2199d8 (undefined)";

      //                     // const arrfiltered2 = arr2.filter(function (elem) {
      //                     //   return elem.value != arr.indexOf(elem).value;
      //                     // });

      //                     // let arrfiltered2 = arr.filter(
      //                     //   word=>!arr2.includes(word)

      //                     // );
      //                     if (list.length >= formData.numberofmentors) {
      //                       swal({
      //                         title: "Info!",
      //                         text: `Maximum ${formData.numberofmentors} Mentor Enrolment Id limit reached.`,
      //                         icon: "info",
      //                       });
      //                     }

      //                     let params = {
      //                       label: arr,
      //                       value: arr,
      //                     };
      //                     // localStorage.removeItem("newEnarray");
      //                     // setIndustryDefault
      //                     setenrolementDefault(list);
      //                     return {
      //                       ...user,
      //                       // enrolementIds2: nodupnewconcatarray,
      //                       enrolementIds2: arr,
      //                     };
      //                   })
      //                 : swal({
      //                     title: "Info!",
      //                     text: `Maximum ${formData.numberofmentors} keywords limit reached.`,
      //                     icon: "info",
      //                   });
      //             }}
      //             // value={formData.industry}
      //             value={formData.enrolementIds2}
      //             //   placeholder = {
      //             //     industryDefault.length > 0 ? industryDefault.map(ele => ele.value) : "Industry"
      //             //  }
      //             onBlur={onBlur}
      //             // defaultValue = {industryDefault.map(ele => ele)}
      //           />
      //           {error.enrolementIds2 &&
      //             renderErrorMessage(error.enrolementIds2)}
      //         </span>
      //         <h6 className="homepageSecondDescription">List of Mentors</h6>

      //         {/* {
      //          formData.mentorenrolmentid && formData.mentorenrolmentid !== "" && formData.mentorenrolmentid !== null && formData?.mentorenrolmentid?.length >=2 ? (
      //             formData.mentorenrolmentid.map((x, i) => (
      //               <>
      //             <div className="container row">
      //               <div className="col-md-9 col-sm-12">
      //                 <InputField
      //                   required={true}
      //                   id="mentorenrolmentid"
      //                   // label="How many average hours can you dedicate for providing mentorship per week?"
      //                   variant="outlined"
      //                   // placeholder="Mentor Enrolment IDs"
      //                   placeholder="Type Here.."
      //                   fullWidth
      //                   // type="number"
      //                   margin="normal"
      //                   name="mentorenrolmentid"
      //                   // className="col-md-6 col-sm-12"
      //                   // onChange={handleInputChange}
      //                   // value={x.mentorenrolmentid}
      //                   value={x}
      //                   // onChange={(e) => {
      //                   //   let data = defaultMentorID[i];
      //                   //   setDefaultMentorID((current) => [...current, data]);

      //                   // }}
      //                   onChange={(e)=>makeMentorEnrolmentId(e,i)}
      //                   // value={formData.mentorenrolmentid}
      //                   // error={error.mentorenrolmentid}
      //                   onBlur={onBlur}
      //                   InputLabelProps={{
      //                     shrink: true,
      //                   }}
      //                   inputProps={{ maxLength: 7 }}
      //                   hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
      //                 />
      //               </div>

      //               <div
      //                 className="btn-box col-md-3 col-sm-12"
      //                 style={{
      //                   display: "flex",
      //                   alignItems: "flex-start",
      //                   marginTop: "1%",
      //                   paddingRight: "0px",
      //                   justifyContent: "left",
      //                   paddingLeft: "0px",
      //                 }}
      //               >
      //                 {formData.mentorenrolmentid.length !== 1 && (
      //                   <button
      //                     className="brd-btn d-inline-block newbtnbottom"
      //                     style={{
      //                       backgroundColor: "#f4f4f4",
      //                       // backgroundColor: "#f4f4f4",
      //                       color: "#3AC2D7",
      //                       // color: "#3AC2D7",
      //                       fontSize: "12px",
      //                       width: "9em",
      //                       marginTop: "0px",
      //                       marginRight: "8px",
      //                       border: "1px solid #00000040",
      //                       borderRadius: "5px",
      //                       paddingTop: "12px",
      //                       paddingBottom: "12px",
      //                       cursor: "pointer",
      //                       zIndex: 0,
      //                     }}
      //                     // className="mr10 red-border-btn-remove"
      //                     // style={{
      //                     //   paddingLeft: "12px",
      //                     //   paddingRight: "12px",
      //                     // }}
      //                     onClick={() => handleRemoveClick(i)}
      //                   >
      //                     Remove
      //                   </button>
      //                 )}
      //                 {formData.mentorenrolmentid.length - 1 === i &&
      //                   formData.mentorenrolmentid.length <
      //                     formData.numberofmentors && (
      //                     <button
      //                       onClick={handleAddClick2}
      //                       // className="green-border-btn-add"
      //                       // style={{
      //                       //   paddingLeft: "25px",
      //                       //   paddingRight: "25px",
      //                       // }}

      //                       className="brd-btn d-inline-block newbtnbottom"
      //                       style={{
      //                         backgroundColor: "#f4f4f4",
      //                         // backgroundColor: "#f4f4f4",
      //                         color: "#3AC2D7",
      //                         // color: "#3AC2D7",
      //                         fontSize: "12px",
      //                         width: "9em",
      //                         marginTop: "0px",
      //                         marginRight: "8px",
      //                         border: "1px solid #00000040",
      //                         borderRadius: "5px",
      //                         paddingTop: "12px",
      //                         paddingBottom: "12px",
      //                         cursor: "pointer",
      //                         zIndex: 0,
      //                         pointerEvents:
      //                           x.mentorenrolmentid === "" ? "none" : "auto",
      //                       }}
      //                     >
      //                       Add
      //                     </button>
      //                   )}
      //               </div>
      //             </div>
      //           </>
      //               ))

      //           ): */}
      //         {/* {mentorEnrolmentIdList.map((x, i) => (
      //           <>
      //             <div className="container row">
      //               <div className="col-md-9 col-sm-12">
      //                 <InputField
      //                   required={true}
      //                   id="mentorenrolmentid"
      //                   // label="How many average hours can you dedicate for providing mentorship per week?"
      //                   variant="outlined"
      //                   // placeholder="Mentor Enrolment IDs"
      //                   placeholder="Type Here.."
      //                   fullWidth
      //                   // type="number"
      //                   margin="normal"
      //                   name="mentorenrolmentid"
      //                   // className="col-md-6 col-sm-12"
      //                   // onChange={handleInputChange}
      //                   value={x.mentorenrolmentid}
      //                   onChange={(e) => handleInputChange(e, i)}
      //                   // onChange={makeMentorEnrolmentId}
      //                   // value={formData.mentorenrolmentid}
      //                   // error={error.mentorenrolmentid}
      //                   onBlur={onBlur}
      //                   InputLabelProps={{
      //                     shrink: true,
      //                   }}
      //                   inputProps={{ maxLength: 7 }}
      //                   hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
      //                 />
      //               </div>

      //               <div
      //                 className="btn-box col-md-3 col-sm-12"
      //                 style={{
      //                   display: "flex",
      //                   alignItems: "flex-start",
      //                   marginTop: "1%",
      //                   paddingRight: "0px",
      //                   justifyContent: "left",
      //                   paddingLeft: "0px",
      //                 }}
      //               >
      //                 {mentorEnrolmentIdList.length !== 1 && (
      //                   <button
      //                     className="brd-btn d-inline-block newbtnbottom"
      //                     style={{
      //                       backgroundColor: "#f4f4f4",
      //                       // backgroundColor: "#f4f4f4",
      //                       color: "#3AC2D7",
      //                       // color: "#3AC2D7",
      //                       fontSize: "12px",
      //                       width: "9em",
      //                       marginTop: "0px",
      //                       marginRight: "8px",
      //                       border: "1px solid #00000040",
      //                       borderRadius: "5px",
      //                       paddingTop: "12px",
      //                       paddingBottom: "12px",
      //                       cursor: "pointer",
      //                       zIndex: 0,
      //                     }}
      //                     // className="mr10 red-border-btn-remove"
      //                     // style={{
      //                     //   paddingLeft: "12px",
      //                     //   paddingRight: "12px",
      //                     // }}
      //                     onClick={() => handleRemoveClick(i)}
      //                   >
      //                     Remove
      //                   </button>
      //                 )}
      //                 {mentorEnrolmentIdList.length - 1 === i &&
      //                   mentorEnrolmentIdList.length <
      //                     formData.numberofmentors && (
      //                     <button
      //                       onClick={handleAddClick}
      //                       // className="green-border-btn-add"
      //                       // style={{
      //                       //   paddingLeft: "25px",
      //                       //   paddingRight: "25px",
      //                       // }}

      //                       className="brd-btn d-inline-block newbtnbottom"
      //                       style={{
      //                         backgroundColor: "#f4f4f4",
      //                         // backgroundColor: "#f4f4f4",
      //                         color: "#3AC2D7",
      //                         // color: "#3AC2D7",
      //                         fontSize: "12px",
      //                         width: "9em",
      //                         marginTop: "0px",
      //                         marginRight: "8px",
      //                         border: "1px solid #00000040",
      //                         borderRadius: "5px",
      //                         paddingTop: "12px",
      //                         paddingBottom: "12px",
      //                         cursor: "pointer",
      //                         zIndex: 0,
      //                         pointerEvents:
      //                           x.mentorenrolmentid === "" ? "none" : "auto",
      //                       }}
      //                     >
      //                       Add
      //                     </button>
      //                   )}
      //               </div>
      //             </div>
      //           </>
      //         ))} */}

      //         {/* {error.mentorenrolmentid
      //           ? renderErrorMessage(error.mentorenrolmentid)
      //           : ""} */}

      //         {/* <div className="formfileuploaddiv">
      //           <FileUpload />
      //         </div> */}
      //         <div className="file_upload mt-2">
      //           <div>
      //             <div className="rowC ">
      //               <div className="col-md-9">
      //                 <p class="upload-mentor-text">Upload List of Mentors</p>
      //                 <p style={{ textAlign: "left" }}>
      //                   <br />
      //                   <span
      //                     className="supported-file"
      //                     style={{ position: "inherit" }}
      //                   >
      //                     Supported file format PDF only upto 10MB
      //                   </span>
      //                 </p>
      //               </div>
      //             </div>
      //             {/* <p className="upload-mentor-text">
      //               Upload Attachment *
      //               <span>
      //                 Supported file format jpeg , png only upto 500KB
      //               </span>
      //             </p> */}

      //             {/* <img id="blah" alt="your image" style={{"width":"100px", "height":"100px" }}/> */}
      //             <input
      //               // required={true}
      //               type="file"
      //               className="mentor-upload"
      //               // name="Upload Document"
      //               id="fileUpload-attach"
      //               required
      //               accept="application/pdf"
      //               name="uploadAttach"
      //               onChange={handleInputChange}
      //               onBlur={onBlur}
      //               // onchange="document.getElementById('blah').src = window.URL.createObjectURL(this.files[0])"
      //             />
      //           </div>
      //         </div>
      //         {error.uploadAttach && renderErrorMessage(error.uploadAttach)}
      //         {formData.uploadAttach && formData.uploadAttach.name ? (
      //           <div className="file-name">
      //             {formData.uploadAttach.name}{" "}
      //             <span
      //               style={{ marginLeft: "10px" }}
      //               onClick={() => removeFile("uploadAttach")}
      //             >
      //               {" "}
      //               X{" "}
      //             </span>
      //           </div>
      //         ) : (
      //           formData.uploadAttach && (
      //             <div className="file-name">
      //               {formData.uploadAttach &&
      //                 formData.uploadAttach.split("/").pop()}
      //               <span
      //                 style={{ marginLeft: "10px" }}
      //                 onClick={() => removeFile("uploadAttach")}
      //               >
      //                 {" "}
      //                 X{" "}
      //               </span>
      //             </div>
      //           )
      //         )}
      //       </div>
      //     </>
      //   );
      case 2:
        return (
          <>
            <div
              className="cohortformsteps row"
              style={{ paddingBottom: "10px" }}
            >
              {/* <h6 className="homepageSecondDescription">
                Expected number of startups per Mentor (maximum limit 15)
              </h6>
             
              <InputField
                // required={true}
                id="numberofstartups"
                // label="How many average hours can you dedicate for providing mentorship per week?"
                variant="outlined"
                // placeholder="Number of startups for each mentor (maximum limit)"
                placeholder={ formData.numberofstartups && formData.numberofstartups  != null && formData.numberofstartups !== "" ? formData.numberofstartups :"Type Here.."}
                fullWidth
                type="text"
                margin="normal"
                name="numberofstartups"
                onKeyDown={(evt) =>
                  (["e", "E", "+", "-"].includes(evt.key) &&
                    evt.preventDefault()) ||
                  ([
                    "A",
                    "B",
                    "C",
                    "D",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                  ].includes(evt.key) &&
                    evt.preventDefault()) ||
                  ([
                    "a",
                    "b",
                    "c",
                    "d",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                  ].includes(evt.key) &&
                    evt.preventDefault())
                }
                className="col-12"
                onChange={handleInputChange}
                value={formData.numberofstartups  != null ? formData.numberofstartups : 0}
                error={error.numberofstartups}
                onBlur={onBlur}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ maxLength: 2 }}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              /> */}
             
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <h6 className="homepageSecondDescription">
                  Industry / Sector (maximum limit upto 10){" "}
                </h6>
                <MultiselectorComp
                  // options={industryOptions}
                  options={
                    getPredefineOptions && getPredefineOptions.industry_options
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Industry "
                  styles={customStyles}
                  // onChange={(v) => (v.length < 6 ? setIndustry(v) : null)}
                  // // allowSelectAll={true}
                  // value={industry}
                  onChange={(list) =>
                    list.length <= 20 - formData.industry.length
                      ? setFormData((user) => {
                          let arr = list.filter(function (item) {
                            return item.value !== "select";
                          });
                          if (list.length >= 10) {
                            swal({
                              title: "Info!",
                              text: "Maximum 10 keywords limit reached.",
                              icon: "info",
                            });
                          }
                          let params = {
                            label: arr,
                            value: arr,
                          };
                          setIndustryDefault(list);
                          return { ...user, industry: arr };
                        })
                      : swal({
                          title: "Info!",
                          text: "Maximum 10 keywords limit reached.",
                          icon: "info",
                        })
                  }
                  // value={formData.industry}
                  value={
                    // industryDefault.length > 0
                    //   ? industryDefault.map((ele) => ele)
                    //   : formData.industry
                    formData.industry
                  }
                  //   placeholder = {
                  //     industryDefault.length > 0 ? industryDefault.map(ele => ele.value) : "Industry"
                  //  }
                  onBlur={onBlur}
                  // defaultValue = {industryDefault.map(ele => ele)}
                />
                {/* {error.industry && renderErrorMessage(error.industry)} */}
              </span>
              {/* {error.subindustry && renderErrorMessage(error.subindustry)} */}
              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <h6 className="homepageSecondDescription">
                  Specialization / Function (Multiple Selection)
                </h6>
                <MultiselectorComp
                  required={true}
                  // options={specializationOptions}x`
                  options={
                    getPredefineOptions && getPredefineOptions._specialisation
                  }
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Specialization "
                  styles={customStyles}
                  // onChange={(v) => (v.length < 4 ? setSpecialization(v) : null)}
                  // onChange={(list) =>
                  //   list.length < 4
                  //     ? setFormData((user) => {
                  //         return { ...user, specialization: list };
                  //       })
                  //     : null
                  // }
                  onChange={(list) =>
                    list.length <= 10
                      ? setFormData((user) => {
                          let arr = list.filter(function (item) {
                            return item.value !== "select";
                          });
                          if (list.length == 10) {
                            swal({
                              title: "Info!",
                              text: "Maximum 10 keywords limit reached.",
                              icon: "info",
                            });
                          }
                          setSpecializationDefault(list);
                          return { ...user, specialization: arr };
                        })
                      : swal({
                          title: "Info!",
                          text: "Maximum 10 keywords limit reached.",
                          icon: "info",
                        })
                  }
                  value={
                    // specializationDefault.length > 0
                    //   ? specializationDefault.map((ele) => ele)
                    //   : formData.specialization
                    formData.specialization
                  }
                  // value={formData.specialization}
                  onBlur={onBlur}
                />
              </span>
              {error.specialization && renderErrorMessage(error.specialization)}

              <span
                class="d-inline-block multiselectorspan"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <h6 className="homepageSecondDescription">
                  Preferred stage of the startup{" "}
                </h6>
                <MultiselectorComp
                  options={preferredOptions}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Preferred stage of the startup"
                  styles={customStyles}
                  allowSelectAll={true}
                  isMulti
                  // defaultValue = {specializationDefault.map(ele => ele)}
                  // value={preferredStage}

                  // onChange={(list) =>
                  //   setFormData((user) => {
                  //     return { ...user, preferredStage: list };
                  //   })
                  // }
                  onChange={(list) =>
                    setFormData((user) => {
                      let arr = list.filter(function (item) {
                        return item.value !== "*";
                      });
                      setStageDefault(list);
                      return { ...user, preferredStage: arr };
                    })
                  }
                  value={
                    // stageDefault.length > 0
                    //   ? stageDefault.map((ele) => ele)
                    //   : formData.preferredStage
                    formData.preferredStage
                  }
                  // value={formData.preferredStage}
                  onBlur={onBlur}
                />
              </span>
              {/* {error.preferredStage && renderErrorMessage(error.preferredStage)} */}
              <div className="file_upload_cohort mt-4" style={{padding:"0",margin:"0",height:"fit-content"}}>
                <div style={{padding:"5px"}}>
                <div className="d-flex" style={{gap:"5px"}}>
                     
                                <h6 className="homepageSecondDescription"  style={{width:"40%",paddingLeft:"10px"}}>
                                  Select the visibility of Cohort*
                                </h6>
                                <div className="d-flex" style={{gap:"10px",width:"35%",justifyContent:"space-evenly"}}>
                            <div className="d-flex">
                          <input
                type="radio"
                name="address"
                style={{minHeight:"1.65rem"}}
                className="radioButtonCohortForm"
                // value={cohortType}
                checked={cohortPublic}
                onChange={()=>{
                  if(history?.location?.state?.mode == "edit"){
                    swal({
                      title: "Info",
                      text: "You are about to change the Cohort from Private to Public. All pending applicants will be auto approved. This action and Cohort cannot be reverted back Private mode.",
                      icon: "info",
                      buttons: {
                        delete: {
                          text: "CONFIRM",
                        },
                        decline: {
                          text: "CANCEL",
                        }
                      }
                    }).then((value) => {
                      if (value === "delete") {
                        setCohortPublic(true);setCohortPrivate(false);
                      } else {
                      
                      }
                    })
                    ;
                  }
                  else{
                    setCohortPublic(true);setCohortPrivate(false);

                  }
                  }}
              />
              <h6 style={{fontSize:"16px",position:"relative",bottom:"2px"}}>Public</h6>
              </div>
              {
                
                <div className="d-flex">
                <input
                  type="radio"
                  name="address"
                  style={{minHeight:"1.65rem"}}
                  className="radioButtonCohortForm"
                  disabled={(history?.location?.state?.data?.cohortVisibility && history?.location?.state?.data?.applicationStatus == "VERIFIED" && history?.location?.state?.mode == "edit")}
                  // disabled={cohortPublic && history?.location?.state?.data?.applicationStatus == "VERIFIED" }
                  // value={cohortType}
                  checked={cohortPrivate}
                  onChange={()=>{setCohortPrivate(true);setCohortPublic(false);}}
                />
                <h6 style={{fontSize:"16px",position:"relative",bottom:"2px"}}>
                Private
                </h6>
                </div>
               } 
             
                                {/* <input
                                  type="checkbox"
                                  className="cohortCheckBox"
                                  name="cohortTimeCheck"
                                  style={{minHeight:"1.65rem"}}
                                  // checked={item?.spotlight}
                                  // onClick={(e) =>
                                  //   spotLightFn(item, !item?.spotlight)
                                  // }
                                /> */}
                                </div>
                              </div>
                              <div className="cohortTypeText">
                              If Public : Any startup or mentor can directly join the cohort without requiring your approval. This is ideal for large cohorts.
                              </div>
                              <div className="cohortTypeText">
                              If Private : Startups or mentors can join after you approve their application. You can accept or decline their application. Members of the cohort communicate with each other through chat.
                              </div>
                              </div>
                              </div>
                              <span style={{marginTop:"1rem",paddingLeft:"0",}} >
                              {formData.cohortVisibility === true
                ? " "
                : error.cohortVisibility && renderErrorMessage(error.cohortVisibility)}
                </span>
            </div>

            <div className="cohortformsteps">
              <div className="disclaimerMaindiv">
                <Checkbox
                  checked={formData.disclaimer}
                  onClick={() => oncheckedChange()}
                  style={{
                    display: "flex",
                    alignSelf: "baseline",
                    position: "relative",
                    top: "1.5rem",
                  }}
                  sx={{
                    color: "#F78F54",
                    "&.Mui-checked": {
                      color: "#F78F54",
                    },
                  }}
                  // onBlur={onBlur}
                />
                <div
                  // style={{
                  //   textAlign: "justify",
                  //   paddingLeft: "10px",
                  // }}
                  className="actualdisclaimer homepageSecondDescription"
                >
                  We are in compliance with the provisions of the various Acts,
                  Rules, Regulations, Guidelines, Standards applicable to the
                  entity from time to time. All information provided by us in
                  the application is true, correct and complete and no
                  information material to the subject matter of this form has
                  been suppressed or concealed. If there is any change in this
                  information or compliance status, I will duly inform Startup
                  India within 15 days on startup.support@investindia.org.in
                </div>
              </div>
              {formData.disclaimer === true
                ? " "
                : error.disclaimer && renderErrorMessage(error.disclaimer)}
            </div>
            {/* {error.disclaimer && renderErrorMessage(error.disclaimer)}
            </div> */}
          </>
        );
      case 3:
        return (
          <>
            <div className="cohortformsteps">
              <div className="disclaimerMaindiv">
                <input
                  type="checkbox"
                  // defaultChecked={checked}
                  // onChange={() => setChecked(!checked)}
                  style={{
                    width: "fit-content",
                    marginTop: "3px",
                  }}
                />
                <div
                  // style={{
                  //   textAlign: "justify",
                  //   paddingLeft: "10px",
                  // }}
                  className="actualdisclaimer homepageSecondDescription"
                >
                  We are in compliance with the provisions of the various Acts,
                  Rules, Regulations, Guidelines, Standards applicable to the
                  entity from time to time. All information provided by us in
                  the application is true, correct and complete and no
                  information material to the subject matter of this form has
                  been suppressed or concealed. If there is any change in this
                  information or compliance status, I will duly inform Startup
                  India within 15 days on startup.support@investindia.org.in
                </div>
              </div>
            </div>
          </>
        );
      default:
        return "unknown step";
    }
  }

  // const steps = getSteps();

  const steps = getSteps();

  const allStepsData = steps.map((step, index) => {
    // alert('activeStep'+activeStep)
    // alert(index)
    // .map(step => {
    return (
      <li
        className={
          activeStep === index
            ? "active"
            : index <= activeStep
            ? "active"
            : "lastStep"
        }
        key={index}
      >
        <span className="count">
          {activeStep == index ? (
            <>{Math.round(formPercentageValue)}%</>
          ) : (
            activeStep === 3 && step === "COHORT PREFERENCES" && "100%"
          )}
        </span>
        <div className="text">
          <p className="homepageSecondDescription">{step}</p>
          {/* {step} */}
        </div>
      </li>
    );
  });
  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const isStepSkipped = (step) => {
    return skippedSteps.includes(step);
  };
  const [theArray, setTheArray] = useState([]);
  const addEntryClick = (value) => {
    setTheArray([...theArray, value]);
  };
  const handleNext = () => {
    // setActiveStep(activeStep + 1);
    setSubmitFormData(formData);
    if (activeStep === 0) {
      if (!validateStep1Input()) {
        setIsNext(false);
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        setIsNext(true);
        if (loginDatajsonNew.applicationStatus === "SUBMITTED") {
        } else {
          addDraftData(formData, "nextdraftbutton");
        }
      }
    } else if (activeStep === 1) {
      if (!validateStep2Input()) {
        setIsNext(false);
        setHasInvalidSubmitOccurred(true);
      } else {
        setActiveStep(activeStep + 1);
        setIsNext(true);
        if (loginDatajsonNew.applicationStatus === "SUBMITTED") {
        } else {
          addDraftData(formData, "nextdraftbutton");
        }
      }
    } 
    //   else if (activeStep === 2) {
    //   if (!validateStep3Input(defaultMentorID)) {
    //     setIsNext(false);
    //     setHasInvalidSubmitOccurred(true);
    //   } else {
    //     setActiveStep(activeStep + 1);
    //     setIsNext(true);
    //     if (loginDatajsonNew.applicationStatus === "SUBMITTED") {
    //     } else {
    //       addDraftData(formData, "nextdraftbutton");
    //     }
    //   }
    // } 
    else if (activeStep === 2) {
      if (!validateStep4Input()) {
        setIsNext(false);
        setHasInvalidSubmitOccurred(true);
      } else {
        // onclickShowSubmitCohort();
        setIsNext(true);
        setActiveStep(activeStep + 1);
        setTimeout(() => {
          addFormData(formData);
        }, 1500);
      }
    }
    setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
  };
  const handleDraft = () => {
    if (activeStep === 0) {
      addDraftData(formData, "savedraftbutton");
    } else if (activeStep === 1) {
      addDraftData(formData, "savedraftbutton");
    } else if (activeStep === 2) {
      addDraftData(formData, "savedraftbutton");
      setTimeout(() => {
        addDraftData(formData, "savedraftbutton");
      }, 1500);
    } else if (activeStep === 3) {
      setTimeout(() => {
        addDraftData(formData, "savedraftbutton");
      }, 1500);
    }

    setSkippedSteps(skippedSteps.filter((skipItem) => skipItem !== activeStep));
    // setSubmitFormData(formData);
  };

  const handleBack = () => {
    setIsPrevious(false);

    setTimeout(() => {
      setIsPrevious(true);
    }, 300);

    setActiveStep(activeStep - 1);
  };

  const addFormData = (submitData) => {
    const newformData = new FormData();
    const industryArray = [];
    const subindustryArray = [];
    const specialityArray = [];
    const enrolementIds2Array = [];

    const preferedStageArray = [];

    submitData?.industry.map((industry) => {
      industryArray.push(industry.value);
    });
    submitData?.subindustry.map((subindustry) => {
      subindustryArray.push(subindustry.value);
    });
    submitData?.enrolementIds2.map((enid) => {
      enrolementIds2Array.push(enid.value);
    });
    submitData?.specialization.map((speciality) => {
      specialityArray.push(speciality.value);
    });
    // submitData?.subspecialization.map((subspecialization) => {
    //   subspecializationArray.push(subspecialization.value);
    // });
    if (
      submitData?.preferredStage?.value !== undefined &&
      submitData?.preferredStage?.value !== null &&
      submitData?.preferredStage?.value !== ""
    ) {
      preferedStageArray.push(submitData?.preferredStage?.value);
    } else {
      submitData?.preferredStage.map((stage) => {
        preferedStageArray.push(stage.value);
      });
    }

    const cohortapplication = {
      id: history?.location?.state?.data?.id,
      cohortId: userId,
      city: submitData.city,
      country: submitData.country,
      current_designation: submitData.current_designation,
      disclaimer: submitData.disclaimer,
      // hoursperweek: submitData.hoursperweek,
      industry: industryArray,
      linkedinurl: submitData.linkedinurl,
      mentor_name: submitData.mentor_name,
      // cohortDate: cohortDate,
      cohort_date: submitData.cohort_date,
      startup_start_date: submitData.startup_start_date,
      startup_end_date: submitData.startup_end_date,
      // startupStartdate: date,
      // startupEnddate: date2,
      // enrolementIds: mentorEnrolmentIdList2,
      //  gender:submitData.gender,
      // mentorenrolmentid: submitData.mentorenrolmentid,
      // mentorenrolmentid: mentorEnrolmentIdList2,
      // mentorenrolmentid: enrolementIds2Array,
      // numberofmentors: submitData.numberofmentors,
      // numberofstartups: submitData.numberofstartups,
      organization_name: submitData.organization_name,
      organization_type: submitData.organization_type,
      personalblogurl: submitData.personalblogurl,
      phone_number: submitData.phone_number,
      preferred_stage: preferedStageArray,
      program_desc: submitData.program_desc,
      program_duration: submitData.program_duration,
      program_duration_text: submitData.program_duration_text,
      program_name: submitData.program_name,
      specialization: specialityArray,

      state: submitData.state,
      infiniteDuration:(submitData.infiniteDuration == "" || submitData.infiniteDuration == null || submitData.infiniteDuration == undefined) ? false : true,
      cohortVisibility:submitData.cohortVisibility,

    };
    newformData.append("application", JSON.stringify(cohortapplication));

    newformData.append("upload_logo", submitData.uploadLogo);
    newformData.append("upload_banner", submitData.uploadBanner);

    // newformData.append("upload_attach", submitData.uploadAttach);
    let applicationStatus = history?.location?.state?.applicationStatus;
    registerCohort(
      newformData,
      history?.location?.state?.mode === "edit" ? "VERIFIED" : "NEW"
    ).then((res) => {
      if (res) {
        if (res) {
          // localStorage.removeItem("SavedLoggedInData");
          // localStorage.removeItem("loggedIn");
          // history.push({
          //   pathname: "/dashboard",
          // });
          setTimeout(() => {
            localStorage.setItem(
              "MyCohortMentorDashboard",
              "MyCohortMentorDashboard"
            );
            // window.location.reload();
            history.push({
              pathname: `/dashboard`,
              state: "cohortForm",
            });
          }, 1000);
        }
       
      }
      // else{
      //   // history.push({
      //   //   pathname: "/dashboard",
      //   // });
      //   setTimeout(() => {
      //     localStorage.setItem(
      //       "cohortApplicationMentor",
      //       "cohortApplicationMentor"
      //     );
      //     // window.location.reload();
      //     history.push({
      //       pathname: `/dashboard`,
      //       state: "cohortForm",
      //     });
      //   }, 1000);
      // }
    });

    // registerCohort(newformData).then((res) => {
    //   if (res) {
    //     if (res) {
    //       // localStorage.removeItem("SavedLoggedInData");
    //       // localStorage.removeItem("loggedIn");
    //       history.push({
    //         pathname: "/",
    //       });
    //     }
    //   }
    // });
  };
  const addDraftData = (submitData, buttontype) => {
    const newformData = new FormData();
    const industryArray = [];
    const subindustryArray = [];
    const specialityArray = [];
    const enrolementIds2Array = [];

    const preferedStageArray = [];

    submitData?.industry.map((industry) => {
      industryArray.push(industry.value);
    });
    submitData?.subindustry.map((subindustry) => {
      subindustryArray.push(subindustry.value);
    });
    submitData?.enrolementIds2.map((enid) => {
      enrolementIds2Array.push(enid.value);
    });
    submitData?.specialization.map((speciality) => {
      specialityArray.push(speciality.value);
    });
    // submitData?.subspecialization.map((subspecialization) => {
    //   subspecializationArray.push(subspecialization.value);
    // });

    submitData?.preferredStage.map((stage) => {
      preferedStageArray.push(stage.value);
    });

    const cohortapplication = {
      cohortId: userId,
      id: history?.location?.state?.data?.id,
      city: submitData.city,
      country: submitData.country,
      current_designation: submitData.current_designation,
      disclaimer: submitData.disclaimer,
      // hoursperweek: submitData.hoursperweek,
      industry: industryArray,
      linkedinurl: submitData.linkedinurl,
      mentor_name: submitData.mentor_name,
      // cohortDate: cohortDate,
      cohort_date: submitData.cohort_date,
      startup_start_date: submitData.startup_start_date,
      startup_end_date: submitData.startup_end_date,
      // startupStartdate: date,
      // startupEnddate: date2,
      // enrolementIds: mentorEnrolmentIdList2,
      //  gender:submitData.gender,
      // gender: submitData.gender.value,
      // mentorenrolmentid: submitData.mentorenrolmentid,
      // mentorenrolmentid: mentorEnrolmentIdList2,
      // mentorenrolmentid: enrolementIds2Array,

      // numberofmentors: submitData.numberofmentors,
      // numberofstartups: submitData.numberofstartups,
      organization_name: submitData.organization_name,
      organization_type: submitData.organization_type,

      personalblogurl: submitData.personalblogurl,
      phone_number: submitData.phone_number,
      preferred_stage: preferedStageArray,
      program_desc: submitData.program_desc,
      program_duration: submitData.program_duration,
      program_duration_text: submitData.program_duration_text,
      program_name: submitData.program_name,
      specialization: specialityArray,

      state: submitData.state,
    };
    newformData.append("application", JSON.stringify(cohortapplication));

    newformData.append("upload_logo", submitData.uploadLogo);
    newformData.append("upload_banner", submitData.uploadBanner);

    // newformData.append("upload_attach", submitData.uploadAttach);

    api.POSTDATA(SAVE_DRAFT_COHORT, newformData).then((response) => {
      if (activeStep == 0) {
        if (response.status === 200) {
          setCohortApplicationId(response.data.data && response.data.data.id);
          // alert(cohortApplicationId)
        }
      }
      if (buttontype == "savedraftbutton") {
        swal({
          title: "Saved Draft",
          text: "Your Cohort Program Saved Successfully !!",
          icon: "success",
        });
      }
      // return response;
    });
    // savedraftCohort(newformData, buttontype).then((res) => {
    //   if (res) {
    //     if (res && buttontype === "savedraftbutton") {
    //     }
    //   }
    // });
  };
  const handleSkip = () => {
    if (!isStepSkipped(activeStep)) {
      setSkippedSteps([...skippedSteps, activeStep]);
    }
    setActiveStep(activeStep + 1);
  };

  
  return (
    <div>
      <Stepper alternativeLabel activeStep={activeStep}>
        {/* {steps.map((step, index) => {
          const labelProps = {};
          const stepProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography
                variant="caption"
                align="center"
                style={{ display: "block" }}
              >
                optional
              </Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step {...stepProps} key={index}>
              <StepLabel {...labelProps}>{step}</StepLabel>
            </Step>
          );
        })} */}
        <Step>
          <div className="row steps-mentor">
            <div className="col-12">
              <ul>{allStepsData}</ul>
            </div>
          </div>
          {/* <StepLabel {...labelProps}>{step.stepName}</StepLabel> */}
        </Step>
      </Stepper>

      {activeStep === steps.length ? (
        <Typography variant="h3" style={{ fontSize: "20px" }} align="center">
          Processing...Please Wait
        </Typography>
      ) : (
        <>
          <form>{getStepContent(activeStep)}</form>
          {activeStep === 0 ? (
            ""
          ) : (
            <>
              <a
                disabled={activeStep === 0}
                onClick={handleBack}
                className="brd-btn d-inline-block newbtnbottommbl cohrotformbtnmobile"
                style={{
                  backgroundColor:
                    isPrevious === true ? "#f4f4f4" : "rgb(58, 194, 215)",
                  // backgroundColor: "#f4f4f4",
                  color: isPrevious === true ? "rgb(58, 194, 215)" : "white",
                  // color: "#3AC2D7",
                  width: "9em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border: "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  cursor: "pointer",
                  zIndex: 0,
                }}
                // title=""
              >
                <i className="fa fa-arrow-left"></i> &nbsp;
                {activeStep === 0 ? "Cancel" : "Previous"}
              </a>
              <a
                disabled={activeStep === 0}
                onClick={handleBack}
                className="brd-btn d-inline-block newbtnbottom cohrotformbtndesk"
                style={{
                  backgroundColor: "#f4f4f4",
                  // backgroundColor: "#f4f4f4",
                  color: "#3AC2D7",
                  // color: "#3AC2D7",
                  width: "9em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border: "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  cursor: "pointer",
                  zIndex: 0,
                }}
                // title=""
              >
                <i className="fa fa-arrow-left"></i> &nbsp;
                {activeStep === 0 ? "Cancel" : "Previous"}
              </a>
            </>
            // <Button
            //   style={{
            //     color: "#3AC2D7",
            //     marginRight: "8px",
            //     backgroundColor: "#f4f4f4",
            //     width: "150px",
            //     border: "1px solid #00000040",
            //     marginTop: "20px",
            //   }}
            //   // className={classes.button}
            //   // variant="outlined"

            //   disabled={activeStep === 0}
            //   color="primary"
            //   onClick={handleBack}
            // >
            //   {/* &#8592; */}
            //   <i className="fa fa-arrow-left"></i> &nbsp;
            //   {activeStep === 0 ? "Cancel" : "previous"}
            // </Button>
          )}
          {/* {isStepOptional(activeStep) && (
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={handleSkip}
            >
              skip
            </Button>
          )} */}
          {/* <Button
        className={classes.button}
        variant="contained"
        color="primary"
        style={{
          // marginRight: theme.spacing(1),
          backgroundColor: "#3AC2D7",
          color: "#fff",
          width: "150px",
          marginTop: "20px",
        }}
        onClick={handleNext}
      >
        {steps && activeStep === steps.length - 1 ? "Submit" : "Next"} &nbsp;
        <i className="fa fa-arrow-right"></i>
      </Button> */}
          <a
            onClick={() => {
              handleNext();
            }}
            className="brd-btn d-inline-block newbtnbottommbl nextbutton-index cohrotformbtnmobile"
            style={{
              backgroundColor:
                isNext === true ? "#f4f4f4" : "rgb(58, 194, 215)",
              // backgroundColor: "#f4f4f4",
              color: isNext === true ? "rgb(58, 194, 215)" : "white",
              // color: "#3AC2D7",
              width: "9em",
              marginTop: "20px",
              marginRight: "8px",
              border: "1px solid #00000040",
              borderRadius: "5px",
              paddingTop: "6px",
              paddingBottom: "6px",
              cursor: "pointer",
              zIndex: 0,
              fontSize: "16px",
              fontWeight: "bold",
            }}
            // title=""
          >
            {steps && activeStep === steps.length - 1 ? "Submit" : "Next"}{" "}
            &nbsp;
            <i className="fa fa-arrow-right"></i>
          </a>
          <a
            onClick={() => {
              handleNext();
            }}
            className="brd-btn d-inline-block newbtnbottom nextbutton-index cohrotformbtndesk"
            style={{
              backgroundColor: "#f4f4f4",
              // backgroundColor: "#f4f4f4",
              color: "#3AC2D7",
              // color: "#3AC2D7",
              width: "9em",
              marginTop: "20px",
              marginRight: "8px",
              border: "1px solid #00000040",
              borderRadius: "5px",
              paddingTop: "6px",
              paddingBottom: "6px",
              cursor: "pointer",
              zIndex: 0,
            }}
            // title=""
          >
            {steps && activeStep === steps.length - 1 ? "Submit" : "Next"}{" "}
            &nbsp;
            <i className="fa fa-arrow-right"></i>
          </a>
          <a
            // disabled={activeStep === 0}
            // onClick={handleBack}
            onClick={handleDraft}
            className="brd-btn d-inline-block newbtnbottom"
            style={{
              backgroundColor: "#f4f4f4",
              // backgroundColor: "#f4f4f4",
              color: "#3AC2D7",
              // color: "#3AC2D7",
              width: "9em",
              marginTop: "20px",
              marginRight: "8px",
              border: "1px solid #00000040",
              borderRadius: "5px",
              paddingTop: "6px",
              paddingBottom: "6px",
              cursor: "pointer",
              zIndex: 0,
            }}
            // title=""
          >
            {/* <i className="fa fa-arrow-left"></i> &nbsp; */}
            {"Save as draft"}
          </a>
        </>
      )}
      <SubmitForm
        // activityFellowId={activityFellowId}
        isOpen={showSubmitCohort}
        className={"form-submit-modal"}
        onClose={clickOnClose}
        submitData={submitFormData}
        formName={"cohort-form"}
        // onCloseafterdelete={onCloseafterdelete}
        // requirementId={requirementId}
        // currentUserId={currentUserId}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
  };
};
export default connect(mapStateToProps, {
  getNamesList,
  registerCohort,
  savedraftCohort,
  getPredefineOptionsList,
})(withRouter(LinearStepperCohort));